import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import {
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Chip } from "@mui/material";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Tooltip from "@mui/material/Tooltip";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { makeStyles } from "@material-ui/core/styles";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CustomDateTimePicker from '../../components/CustomDateTimePicker';
import CustomerTimePicker from '../../components/CustomTimePicker'
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Card, Divider, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { HighlightOff, InfoRounded, Done } from "@material-ui/icons";
import LinearProgress from "@material-ui/core/LinearProgress";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import clsx from 'clsx';
import CancelIcon from "@mui/icons-material/Cancel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import PaymentIcon from "@material-ui/icons/Payment";
import PhoneIcon from "@material-ui/icons/Phone";
import axios from "axios";
import {
  usePlacesWidget,
} from "react-google-autocomplete";
import { getUserId } from "../../Utils/Common";
import moment from "moment";
import MaterialAuto from "./MaterialAuto";
import MaterialAuto1 from "./MaterialAuto1";
import Geocode from "react-geocode";
import { Skeleton } from "@material-ui/lab";
import { useCompanyTheme } from '../../context/CompanyContext';
import { backendUrl, anonKey, adminBackend, swissCompanyId } from '../../config';
import { bookingEnabled } from '../../config';


const countries = [
  { code: "AD", label: "Andorra", phone: "376" },
  { code: "AE", label: "United Arab Emirates", phone: "971" },
  { code: "AF", label: "Afghanistan", phone: "93" },
  { code: "AG", label: "Antigua and Barbuda", phone: "1-268" },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AL", label: "Albania", phone: "355" },
  { code: "AM", label: "Armenia", phone: "374" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarctica", phone: "672" },
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AS", label: "American Samoa", phone: "1-684" },
  { code: "AT", label: "Austria", phone: "43" },
  { code: "AU", label: "Australia", phone: "61", suggested: true },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland Islands", phone: "358" },
  { code: "AZ", label: "Azerbaijan", phone: "994" },
  { code: "BA", label: "Bosnia and Herzegovina", phone: "387" },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BE", label: "Belgium", phone: "32" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "Saint Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivia", phone: "591" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvet Island", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BZ", label: "Belize", phone: "501" },
  { code: "CA", label: "Canada", phone: "1", suggested: true },
  { code: "CC", label: "Cocos (Keeling) Islands", phone: "61" },
  { code: "CD", label: "Congo, Democratic Republic of the", phone: "243" },
  { code: "CF", label: "Central African Republic", phone: "236" },
  { code: "CG", label: "Congo, Republic of the", phone: "242" },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225" },
  { code: "CK", label: "Cook Islands", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Cameroon", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Cuba", phone: "53" },
  { code: "CV", label: "Cape Verde", phone: "238" },
  { code: "CW", label: "Curacao", phone: "599" },
  { code: "CX", label: "Christmas Island", phone: "61" },
  { code: "CY", label: "Cyprus", phone: "357" },
  { code: "CZ", label: "Czech Republic", phone: "420" },
  { code: "DE", label: "Germany", phone: "49", suggested: true },
  { code: "DJ", label: "Djibouti", phone: "253" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  { code: "DO", label: "Dominican Republic", phone: "1-809" },
  { code: "DZ", label: "Algeria", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EE", label: "Estonia", phone: "372" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "EH", label: "Western Sahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "ET", label: "Ethiopia", phone: "251" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "FJ", label: "Fiji", phone: "679" },
  { code: "FK", label: "Falkland Islands (Malvinas)", phone: "500" },
  { code: "FM", label: "Micronesia, Federated States of", phone: "691" },
  { code: "FO", label: "Faroe Islands", phone: "298" },
  { code: "FR", label: "France", phone: "33", suggested: true },
  { code: "GA", label: "Gabon", phone: "241" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GE", label: "Georgia", phone: "995" },
  { code: "GF", label: "French Guiana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Greenland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240" },
  { code: "GR", label: "Greece", phone: "30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
  },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hong Kong", phone: "852" },
  { code: "HM", label: "Heard Island and McDonald Islands", phone: "672" },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HR", label: "Croatia", phone: "385" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "India", phone: "91" },
  { code: "IO", label: "British Indian Ocean Territory", phone: "246" },
  { code: "IQ", label: "Iraq", phone: "964" },
  { code: "IR", label: "Iran, Islamic Republic of", phone: "98" },
  { code: "IS", label: "Iceland", phone: "354" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaica", phone: "1-876" },
  { code: "JO", label: "Jordan", phone: "962" },
  { code: "JP", label: "Japan", phone: "81", suggested: true },
  { code: "KE", label: "Kenya", phone: "254" },
  { code: "KG", label: "Kyrgyzstan", phone: "996" },
  { code: "KH", label: "Cambodia", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Comoros", phone: "269" },
  { code: "KN", label: "Saint Kitts and Nevis", phone: "1-869" },
  { code: "KP", label: "Korea, Democratic People's Republic of", phone: "850" },
  { code: "KR", label: "Korea, Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman Islands", phone: "1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  { code: "LA", label: "Lao People's Democratic Republic", phone: "856" },
  { code: "LB", label: "Lebanon", phone: "961" },
  { code: "LC", label: "Saint Lucia", phone: "1-758" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LT", label: "Lithuania", phone: "370" },
  { code: "LU", label: "Luxembourg", phone: "352" },
  { code: "LV", label: "Latvia", phone: "371" },
  { code: "LY", label: "Libya", phone: "218" },
  { code: "MA", label: "Morocco", phone: "212" },
  { code: "MC", label: "Monaco", phone: "377" },
  { code: "MD", label: "Moldova, Republic of", phone: "373" },
  { code: "ME", label: "Montenegro", phone: "382" },
  { code: "MF", label: "Saint Martin (French part)", phone: "590" },
  { code: "MG", label: "Madagascar", phone: "261" },
  { code: "MH", label: "Marshall Islands", phone: "692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
  },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolia", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  { code: "MP", label: "Northern Mariana Islands", phone: "1-670" },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauritania", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Maldives", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mozambique", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "New Caledonia", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolk Island", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "French Polynesia", phone: "689" },
  { code: "PG", label: "Papua New Guinea", phone: "675" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PL", label: "Poland", phone: "48" },
  { code: "PM", label: "Saint Pierre and Miquelon", phone: "508" },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  { code: "PS", label: "Palestine, State of", phone: "970" },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RS", label: "Serbia", phone: "381" },
  { code: "RU", label: "Russian Federation", phone: "7" },
  { code: "RW", label: "Rwanda", phone: "250" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SB", label: "Solomon Islands", phone: "677" },
  { code: "SC", label: "Seychelles", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SH", label: "Saint Helena", phone: "290" },
  { code: "SI", label: "Slovenia", phone: "386" },
  { code: "SJ", label: "Svalbard and Jan Mayen", phone: "47" },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Suriname", phone: "597" },
  { code: "SS", label: "South Sudan", phone: "211" },
  { code: "ST", label: "Sao Tome and Principe", phone: "239" },
  { code: "SV", label: "El Salvador", phone: "503" },
  { code: "SX", label: "Sint Maarten (Dutch part)", phone: "1-721" },
  { code: "SY", label: "Syrian Arab Republic", phone: "963" },
  { code: "SZ", label: "Swaziland", phone: "268" },
  { code: "TC", label: "Turks and Caicos Islands", phone: "1-649" },
  { code: "TD", label: "Chad", phone: "235" },
  { code: "TF", label: "French Southern Territories", phone: "262" },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tajikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunisia", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TR", label: "Turkey", phone: "90" },
  { code: "TT", label: "Trinidad and Tobago", phone: "1-868" },
  { code: "TV", label: "Tuvalu", phone: "688" },
  { code: "TW", label: "Taiwan, Province of China", phone: "886" },
  { code: "TZ", label: "United Republic of Tanzania", phone: "255" },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "UG", label: "Uganda", phone: "256" },
  { code: "US", label: "United States", phone: "1", suggested: true },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
  { code: "VA", label: "Holy See (Vatican City State)", phone: "379" },
  { code: "VC", label: "Saint Vincent and the Grenadines", phone: "1-784" },
  { code: "VE", label: "Venezuela", phone: "58" },
  { code: "VG", label: "British Virgin Islands", phone: "1-284" },
  { code: "VI", label: "US Virgin Islands", phone: "1-340" },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis and Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "YE", label: "Yemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },
  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "ZM", label: "Zambia", phone: "260" },
  { code: "ZW", label: "Zimbabwe", phone: "263" },
];

const vehicleArray = [
  {
    vehicleType: "sedan",
    vehicleName: "SEDAN",
    available: "2",
    price: "-",
    orginalPrice: "20",
  },
  {
    vehicleType: "xl",
    vehicleName: "XL",
    available: "5",
    price: "-",
    orginalPrice: "70",
  },
  {
    vehicleType: "vipplus",
    vehicleName: "VIP PLUS",
    available: "1",
    price: "-",
    orginalPrice: "100",
  },
  {
    vehicleType: "vip",
    vehicleName: "VIP",
    available: "1",
    price: "-",
    orginalPrice: "90",
  },

  {
    vehicleType: "aeexpresspickup",
    vehicleName: "AE EXPRESS PICKUP",
    available: "1",
    price: "-",
    orginalPrice: "90",
  },
];

const TaxiModelArray = [
  ["LEXUS ES 300H"],
  ["Toyota Highlander", "Toyota Previa", "Honda Odyssey", "KIA Carinival"],
  [
    "GMC Yukon XL",
    "Chevrolet Traverse",
    "Chevrolet Suburban",
    // 'Mercedes Viano',
    "VOLKSWAGON TERAMONT",
  ],
  [
    "Mercedes S-CLass",
    "Cadillac Escalae ESV",
    "Mercedes V-Class",
    "TESLA Model Y",
  ],
  ["Mercedes S-CLass", "TESLA Model Y"],
];

var hrArray = [];
var minArray = [];

for (let i = 1; i <= 12; i++) {
  if (i <= 9) {
    i = "0" + i;
  } else {
    i = "" + i;
  }
  hrArray.push(i);
}

for (let i = 1; i <= 60; i++) {
  if (i <= 9) {
    i = "0" + i;
  } else {
    i = "" + i;
  }
  minArray.push(i);
}

export const useStyles = makeStyles((muiTheme) => ({
  root: {
    inputRoot: {
      borderTopRightRadius: "0px",
      borderBottomRightRadius: "0px",
    },
    "& > *": {
      margin: muiTheme.spacing(1),
      width: muiTheme.spacing(16),
      height: muiTheme.spacing(16),
    },
    ".MuiStepConnector-lineVertical": {
      borderLeftWidth: "2px",
    },
  },
  newDesignRoot: {
    [muiTheme.breakpoints.down("sm")]: {
      marginTop: "10%",
    },
    [muiTheme.breakpoints.up("md")]: {
      width: "100%",
      position: "absolute",
      overflowX: "hidden",
      overflowY: "auto",
      top: "0px",
      bottom: "20px",
      zIndex: "2",
      left: "0px",
      right: "0px",
      // padding: '10px',
      backgroundColor: "#f6f6f6",
    },
  },
  taxiPadding: {
    [muiTheme.breakpoints.down("sm")]: {
      padding: "4px",
    },
    [muiTheme.breakpoints.up("md")]: {
      padding: "12px",
    },
  },
  formHead: {
    backgroundColor: "#f9fafb",
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  formContent: {
    [muiTheme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
  paper: {
    width: "400px",
    maxWidth: "400px",
    height: "85vh",
    borderRadius: "2px",
    overflow: "hidden",
  },
  countryCode: {
    position: "absolute",
    width: "376px",
    maxWidth: "400px",
    height: "40invh",
    borderRadius: "2px",
    overflow: "hidden",
  },
  searchResult: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "6px",
    justifyContent: "center",
    marginBottom: "8px",
    cursor: "pointer",
    backgroundColor: "#f9fafb",
    "&:hover": {
      backgroundColor: "#e8eced",
    },
  },
  cardPaper: {
    height: "180px",
    backgroundColor: "#f9fafb",
    padding: "6px",
    overflow: "hidden",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#abe1d9",
    },
  },
  cardPaperBackground: {
    backgroundColor: "#f9fafb",
  },
  cardPaperInvertBackground: {
    backgroundColor: "#f9fafb",
    "&:hover": {
      backgroundColor: "#e8eced",
    },
  },
  activeBox: (props) => ({
    // backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    // color: 'white',
    // '&:hover': {
    //   backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    // },
    border: `2px solid ${props.companyTheme?.primaryColorCode}`,
    color: props.companyTheme?.primaryColorCode,
    '&:hover': {
      backgroundColor: '#cccccc',
    },
  }),

  cardSubscription: (props) => ({
    backgroundColor: 'white',
    width: '120px',
    height: '100px',
    display: 'flex',
    color: props.companyTheme?.primaryColorCode,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '8px',
    // border: `2px solid ${props.companyTheme?.secondary}`,
    cursor: 'pointer',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: props.companyTheme?.secondaryColorCode,
      color: props.companyTheme?.primaryColorCode,
    },
  }),

  activePlan: (props) => ({
    backgroundColor: props.companyTheme?.primaryColorCode,
    color: "white",
    width: "120px",
    height: "100px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      backgroundColor: props.companyTheme?.primaryColorCode || '#000',
    },
  }),

  vehicleRequestButton: (props) => ({
    width: '100%',
    backgroundColor: props.companyTheme?.primaryColorCode || 'black',
    borderRadius: '2px',
    padding: muiTheme.spacing(1),
    '&:hover': {
      backgroundColor: props.companyTheme?.hover,
    },
  }),
  headingBox: {
    padding: muiTheme.spacing(1, 3),
    backgroundColor: "#212121",
    color: "#f9fafb",
  },
  margin: {
    width: "90%",
    backgroundColor: "#f6f6f6",
    display: "flex",
    margin: "0 auto",
    marginTop: "20px",
    height: "50px",
  },
  searchHeading: {
    padding: muiTheme.spacing(5, 3),
    color: "#f9fafb",
  },
  fromStepper: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#343434",
    },
  },
  searchContainerMain: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "400px",
    height: "400px",
    width: "100%",
    overflowX: "hidden",
  },
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "270px",
    height: "270px",
    width: "100%",
    overflowX: "hidden",
  },
  vehicleDisplayContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafb",
    width: "100%",
    overflowX: "hidden",
    paddingBottom: "107px",
  },
  vehicleDisplayContainerGrid: {
    display: "flex",
    overflowX: "hidden",
    padding: "14px",
    width: "37%",
  },
  vehicleDetailContainerGrid: {
    paddingBottom: "150px",
    padding: "24px",
  },
  searchResultIcon: {
    display: "flex",
    paddingLeft: "24px",
    paddingRight: "24px",
  },
  searchResultDetailIcon: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: "24px",
    minHeight: "300px",
    height: "300px",
    paddingRight: "24px",
  },
  ResultIcon: {
    backgroundColor: "lightgrey",
    padding: "12px",
    width: "20px",
    height: "20px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100px",
    display: "flex",
    flexDirection: "column",
  },
  searchResultData: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    paddingRight: "20px",
  },
  searchResultDataPrice: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    paddingRight: "20px",
    marginBottom: "8px",
    textAlign: "right",
  },
  resultHeading: {
    fontWeight: "bold",
    fontSize: "18px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  vehicleSelectHeader: {
    fontWeight: "bold",
    fontSize: "18px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  resultSub: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: "normal",
    fontSize: "14px",
  },
  resultSubTime: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontWeight: "normal",
    fontSize: "12px",
    marginBottom: "8px",
  },
  imgClass: {
    width: "70px",
    height: "70px",
  },
  vehicleRequest: {
    backgroundColor: "#f9fafb",
    borderTop: "1px solid grey",
    padding: muiTheme.spacing(2),
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
  },
  vehicleRequestButton: ({ companyTheme }) => ({
    width: "100%",
    backgroundColor: "black",
    borderRadius: "2px",
    padding: muiTheme.spacing(1),
    "&:hover": {
      backgroundColor: companyTheme?.primaryColorCode,
    },
  }),
  paymentTypeBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: muiTheme.spacing(0, 0, 1, 0),
  },
  paymentType: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    color: muiTheme.palette.text.secondary,
    marginRight: muiTheme.spacing(2),
  },
  hover: {
    "&:hover": {
      backgroundColor: "#343434",
    },
  },
  textFiledAddress: {
    ".MuiOutlinedInput-root": {
      borderRadius: "0px",
    },
  },
}));



const ConfirmedDriverSkel = () => {
  const classes = useStyles();

  return (
    <Box className={classes.vehicleDisplayContainer}>
      <Box
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <Skeleton animation="wave" height={40} width="100%" />
          <Skeleton animation="wave" height={40} width="100%" />
          <Skeleton animation="wave" height={40} width="100%" />
        </Box>
        <Box
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "row-reverse",
          }}
        >
          <Skeleton variant="circle" animation="wave" height={80} width={80} />
        </Box>
      </Box>
      <Box
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "50px",
              height: "50px",
              borderRadius: "100px",
              justifyContent: "center",
              color: "blue",
              cursor: "pointer",
              marginBottom: "12px",
            }}
          >
            <Skeleton
              variant="circle"
              animation="wave"
              height={50}
              width={50}
            />
          </Box>

          <Skeleton animation="wave" height={40} width={60} />
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "50px",
              height: "50px",
              borderRadius: "100px",
              justifyContent: "center",
              color: "blue",
              cursor: "pointer",
              marginBottom: "12px",
            }}
          >
            <Skeleton
              variant="circle"
              animation="wave"
              height={50}
              width={50}
            />
          </Box>

          <Skeleton animation="wave" height={40} width={60} />
        </Box>
      </Box>
      <Box
        style={{
          padding: "0 12px",
        }}
      >
        <Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                padding: "12px 0",
                borderBottom: "1px solid lightgrey",
                width: "100%",
              }}
            >
              <Skeleton animation="wave" height={40} width="70%" />
            </Box>
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                padding: "12px 0",
                borderBottom: "1px solid lightgrey",
                width: "100%",
              }}
            >
              <Skeleton animation="wave" height={40} width="70%" />
            </Box>
          </Box>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                padding: "12px 0",
                borderBottom: "1px solid lightgrey",
                width: "100%",
              }}
            >
              <Skeleton animation="wave" height={40} width="70%" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
function getDriverByModel(driverDetails, modelId) {
  let driverByModel = [];
  if (driverDetails) {
    for (let i = 0; i < driverDetails.length; i++) {
      if (driverDetails[i].taxi_model == modelId) {
        driverByModel.push(driverDetails[i]);
      }
    }
  }
  return driverByModel;
}

const VehicleDisplay = ({
  setDetailViewIndex,
  fareDetails,
  fareDetails1,
  modelList,
  driverDetails,
  setSelectedModel,
  setDriverMarkerData,
  driverETA,
  bookType,
  activeIndex,
  setActiveIndex,
  pickUp,
  selectedModel,
  drop,
  setApproxTripFare,
  modelCat,
  setModelCat,
  baseFare,
  setBaseFare,
  planBaseFare,
  setPlanBaseFare, setTwoWayBaseFare, splitDetails, companyId,
  companyTheme,
  hourlyErr

}) => {


  const subModelList = Array.isArray(modelCat)
    ? modelCat
    : typeof modelCat === "string"
      ? modelCat.split(",")
      : [];

  // console.log("selectedModel", selectedModel);

  const classes = useStyles({ companyTheme });

  // const { companyTheme } = useCompanyTheme();


  const activeClick = (e, index) => {
    let model = fareDetails[index];

    // console.log("model",model);

    setModelCat(model?.car_make);
    // setModelCat()
    setActiveIndex(index);
    model.image = `/static/images/${vehicleArray[index].vehicleType}.png`;
    setSelectedModel(model);
    setBaseFare(model.fare);
    setPlanBaseFare(model.fare);
    setTwoWayBaseFare(model.fare);
    setApproxTripFare(model.fare);
  };

  return (
    <>
      <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
        <Grid container spacing={0} alignItems="center">

          <Grid item xs={4} className={classes.formContent}>
            <Box>
              <Typography
                style={{ fontSize: "14px", fontWeight: "400" }}
                variaint="subtitle2"
              >
                Car Type
              </Typography>
            </Box>
          </Grid>

          {fareDetails.length > 0 ? (
            <Grid
              container
              item
              md={8}
              xs={4}
              flexDirection="row"
              className={classes.formContent}

            >
              <Box
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "6px",
                  justifyContent: "flex-start",
                  // alignItems: "flex-start",
                  paddingBottom: "10px",
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  scrollbarWidth: 'none',
                }}
              >
                {fareDetails.map((data, index) =>

                  data.model_name ? (
                    <Grid
                      item
                      justifyContent="flex-start"
                      key={`fare-model-${data._id || index}`}
                    >
                      <Box
                        style={{
                          height: "90px",
                          width: "80px",
                          flexShrink: 0,
                          flexDirection: "column",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",

                        }}
                        boxShadow={2}
                        className={clsx(classes.searchResult, {
                          [classes.activeBox]: index === activeIndex,
                          [classes.cardPaperInvertBackground]: index !== activeIndex,
                        })}
                        onClick={(e) => activeClick(e, index)}
                      >
                        <Box
                          style={{
                            flexGrow: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingBottom: "2px",
                          }}
                        >
                          {vehicleArray &&
                            vehicleArray[index] &&
                            vehicleArray[index].vehicleType ? (
                            <img
                              src={
                                index === activeIndex
                                  ? data?.afterSelect ||
                                  `/static/images/${vehicleArray[index]?.vehicleType}.png`
                                  : data?.beforeSelect ||
                                  `/static/images/${vehicleArray[index]?.vehicleType}.png`
                              }
                              alt={data.model_name || "vehicle"}
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                width: "auto",
                                marginBottom: data.model_name === "AE EXPRESS PICKUP" ? "-15px" : ""
                              }}
                            />
                          ) : (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            </div>
                          )}
                        </Box>

                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "center",
                          }}
                        >
                          {data.model_name && (
                            <Typography
                              variant="subtitle2"
                              style={{ fontSize: "11px", fontWeight: "400", lineHeight: "1.1" }}
                            >
                              {data.model_name}
                            </Typography>
                          )}
                          <Box display="flex" alignItems="center" justifyContent="center">
                            <Typography
                              variant="subtitle2"
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                              }}
                            >
                              {pickUp.address !== "" && drop.address !== ""
                                ? bookType === 0
                                  ? data.fare
                                    ? "AED " + data.fare
                                    : ""
                                  : bookType === 1
                                    ? data.full_day
                                      ? "AED " + data.full_day
                                      : ""
                                    : bookType === 2
                                      ? data.half_day
                                        ? "AED " + data.half_day
                                        : ""
                                      : bookType === 3
                                        ? data.fare
                                          ? "AED " + data.fare
                                          : ""
                                        : ""
                                : ""}
                            </Typography>
                          </Box>
                          <Typography variant="subtitle2" style={{ color: "#606060", fontSize: "9px" }}>
                            {index == activeIndex &&
                              driverETA > 0 &&
                              getDriverByModel(driverDetails, data.modelId).length > 0
                              ? "ETA: " + (driverETA / 60).toFixed(2) + " mins"
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ) : (
                    ""
                  )
                )}
              </Box>

              {subModelList.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    marginTop: "10px",
                    color: companyTheme?.primaryColorCode,
                    minHeight: "25px",
                    alignItems: "flex-start",
                    overflow: "hidden",
                    width: "100%",
                  }}
                >
                  {subModelList
                    .filter((m) => m?.trim())
                    .map((model, index) => (
                      <Chip
                        key={`chip-${index}`}
                        label={model.trim()}
                        variant="outlined"
                        sx={{
                          borderColor: companyTheme?.primaryColorCode,
                          color: companyTheme?.primaryColorCode,
                          fontSize: "11px",
                          height: "25px",
                          minWidth: "60px",
                          "& .MuiChip-label": {
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                          },
                        }}
                      />
                    ))}
                </Box>
              )}

            </Grid>
          ) : (
            <Grid container item md={8} xs={4} flexDirection="row" className={classes.formContent}>
              <Box
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "6px",
                  paddingBottom: "10px",
                  overflowX: "auto",
                  scrollbarWidth: 'none',
                }}
              >
                {[1, 2, 3, 4].map((_, index) => (
                  <Box
                    key={index}
                    style={{
                      height: "90px",
                      width: "80px",
                      flexShrink: 0,
                      borderRadius: "6px",
                      padding: "10px",
                    }}
                    boxShadow={2}
                  >
                    <Skeleton variant="rectangular" height={50} width="100%" />
                    <Skeleton variant="text" height={12} width="80%" style={{ marginTop: 6 }} />
                    <Skeleton variant="text" height={12} width="60%" />
                  </Box>
                ))}
              </Box>
            </Grid>
          )}

        </Grid>
      </Box>
      <Box style={{ flexGrow: 1, marginTop: "8px", marginLeft: '60px' }}>
        <Grid
          container
          spacing={1}
          flexDirection="column"
          alignItems="flex-end"
        >
          <Grid item xs={4}>
            <Typography style={{ fontSize: "14px", fontWeight: "400", }}>

            </Typography>
          </Grid>

          {hourlyErr && (
            <Typography
              color="error"
              variant="caption"
              sx={{
                mt: 0.5,
                display: 'block',
                opacity: 1,
                height: 'auto',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out'
              }}
            >
              For the selected model, hourly fare is set to 0.
              Please update the hourly fare and try again.
            </Typography>
          )}
        </Grid>
      </Box>
    </>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const API_KEY = process.env.REACT_APP_GEO_API_KEY;
const { BACKEND_URL } = backendUrl;
const { ANON_KEY } = anonKey;
const { ADMIN_BACKEND_URL } = adminBackend;

const { swiss_id } = swissCompanyId;


const BookButton = ({
  selectedModel,
  driverDetails,
  dateValue,
  pickUp,
  drop,
  setsearchingDriver,
  setshowErrorMessage,
  setTripID,
  bookType,
  setBookType,
  transferStatus,
  setTransferStatus,
  fullDayStatus,
  setFullDayStatus,
  halfDayStatus,
  setHalfDayStatus,
  subscriptionStatus,
  setSubscriptionStatus,
  hourlyStatus,
  setHourlyStatus,
  setApproxTripFare,
  fareDetails,
  activeIndex,
  // setRoundTripStatus,
  // roundTripStatus,
  guest,
  approxTripFare,
  error,
  setError,
  distance,
  duration,
  startDate,
  endDate,
  time,
  setStartDate,
  setEndDate,
  setTime,
  setPickup,
  setDrop,
  planBaseFare,
  selectedDays,
  selectedHourlyTime,
  subscriptionTripFare,
  twoWayPickupTime,
  dayTimeState,
  waypoints,
  pickUp1,
  drop1,
  twoWaypoints,
  twoWayBaseFare,
  twoWayTripFare,
  selectedHourlyBookingTime,
  recurringBookingEnable,
  fareDetails1,
  companyId,
  companyTheme,
  modelHourlyFare,
  duration2,
  distance2,
  setHourlyErr
}) => {




  const classes = useStyles({ companyTheme });


  const [paymentValue, setPaymentValue] = useState(1);

  const [open, setOpen] = useState(false);

  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [openAdd3, setOpenAdd3] = React.useState(false);

  const [openAdd4, setOpenAdd4] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("Something went wrong");
  const [val, setVal] = useState("");
  const [newUser, setNewUser] = useState(null);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));

  var otp = sessionStorage.getItem("otp");
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);

  const handleChangeType = (event) => {
    let model = fareDetails[activeIndex];
    // console.log(event.target.value);
    let bookType1 = event;
    // console.log(this);
    // console.log("bookType1", bookType1);

    if (bookType1 === "FullDay") {
      setBookType(1);
      if (model) {
        setApproxTripFare(model.full_day);
      }

      setHalfDayStatus(false);
      setTransferStatus(false);
      setFullDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "HalfDay") {
      setBookType(2);
      if (model) {
        setApproxTripFare(model.half_day);
      }

      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Transfer") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(true);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      setHourlyErr(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Subscription") {
      setBookType(3);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(true);
      setHourlyStatus(false);
      setHourlyErr(false);
      // setRoundTripStatus(false);
    }
    else if (bookType1 === "Hourly") {
      setBookType(4);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(true);
      // setRoundTripStatus(false);
    }
  };

  useEffect(() => { }, []);

  Geocode.setApiKey(API_KEY);

  // set response language. Defaults to english.
  Geocode.setLanguage("en");

  // set response region. Its optional.
  // A Geocoding request with region=es (Spain) will return the Spanish city.
  Geocode.setRegion("ae");

  // Enable or disable logs. Its optional.
  Geocode.enableDebug();

  function getPassengerUpdate(trip_id) {
    //   // console.log("Helllllooooo", pickupLatLng.lat());

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        if (Response.data.status == 1) {
          let fareDetails = Response.data.fare_details;
          // setTripInProgress(true);
          setTripID(trip_id);
          setsearchingDriver(false);
          //setshowErrorMessage("")

          // alert(Response.data.message);
          // setshowErrorMessage(Response.data.message)
        } else {
          //   setSearchingCar(false);
          // alert(Response.data.message);
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        // console.log("error Comes:", error);
      });
  }

  const handleOtpCheck = () => {
    // const items = JSON.parse(sessionStorage.getItem('items'));
    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    const obj = {
      name: a.firstName + " " + a.lastName,
      countryCode: `+${a.countryCode}`,
      phone: a.mobileNumber,
      companyId: 7,
      type: 1,
      email: a.email
    };


    setLoader2(true);


    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader1(false);
          setNewUser(Response.data.newUser);
          sessionStorage.setItem(
            "newUser",
            JSON.stringify({ newUser: Response.data.newUser })
          );

          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));


          handleClickOpenOtp();
        } else if (Response.data.status === -1) {
          handleCloseOtp();
          setLoader1(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          // setOpenAdd3(true);
          setOpenAdd4(true);
        } else {
          handleCloseOtp();
          setCountDown(null);
          setLoader1(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        setCountDown(null);
        console.log(error);
      });
  };

  // useEffect(() => {
  //   if (countDown !== null && countDown !== 0) {
  //     const interval = setInterval(() => {
  //       setCountDown(countDown - 1);
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   }
  // }, [countDown]);

  const ResendOtp = () => {
    let obj;

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    if (bookType === 3) {
      obj = {
        name: a.firstName + " " + a.lastName,
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1, // Only included if bookType is 3
        email: a.email
      };
    } else {
      obj = {
        name: a.firstName + " " + a.lastName,
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        email: a.email
      };
    }

    setLoader3(true);

    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader3(false);
          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

        } else if (Response.data.status === -1) {
          setLoader3(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          setCountDown(null);
          setLoader3(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeValidate = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }
  };

  const handleAddClose3 = () => {
    setOpenAdd3(false);
  };

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose31 = () => {
    setOpenAdd3(false);
    // setOpenOtp(false);
  };

  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleClickOpenOtp = () => {
    setOpenOtp(true);
  };

  const handleCloseOtp = () => {
    setOpenOtp(false);
  };


  // console.log("openOtp", openOtp);


  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));


    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader2(true);

    // setsearchingDriver(true);

    if (bookType === 3) {
      const formattedStartDate = moment(startDate).format("YYYY-MM-DD HH:mm:ss");


      const formattedEndDate = moment(endDate).format("YYYY-MM-DD HH:mm:ss");



      // console.log("planBaseFare", planBaseFare);

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");

      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      // console.log(dropLocationInfo);

      // console.log("twoWayBaseFare", twoWayBaseFare);

      const domain = sessionStorage.getItem("x_company_domain");



      const postData = {
        _id: passengerId?.passengerId,
        newUser: newUser,
        motorModelId: selectedModel._id,
        otp: otp,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: pickUp.address,
          latitude: pickUp.coords.lat(),
          longitude: pickUp.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        // twoWayPickupTime: formattedTwoWayPickupTime,
        farePerTrip: planBaseFare,
        totalFare: subscriptionTripFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        daySlot: selectedDays,
        hours: selectedHourlyTime,
        recurringBookingEnable: recurringBookingEnable,
        ...(subscriptionDetailsNew?.tripType === 2 && {

          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayPickupLocationInfo: {
            address: pickUp1.address,
            latitude: pickUp1.coords.lat(),
            longitude: pickUp1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayBaseFare,
          twoWaytotalFare: twoWayTripFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };

      // console.log("passsengerId", passsengerId);

      console.log("selectedHourlyTime", selectedHourlyTime);

      axios
        .post(
          `${BACKEND_URL}/createEnquiry?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          if (Response.data.status >= 1) {
            setOpenOtp(false);
            setAlertMsg(Response.data.message);
            setshowErrorMessage(Response.data);
            setLoader2(false);
            setOpenAdd3Success(true);

            sessionStorage.setItem(
              "passengerInfo",
              JSON.stringify(Response?.data?.detail?.passengerInfo)
            );

            const obj2 = {
              passengerId: Response?.data?.detail?.passengerInfo?.id,
            };
            sessionStorage.setItem("passengerId", JSON.stringify(obj2));
          }
          else {
            setBookType(3);

            if (Response.data.isVerified) {
              setOpenOtp(false);
            } else {
              setOpenOtp(true);
            }
            setAlertMsg(Response.data.message);
            setLoader2(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1]; // "AED" if needed
          const fareAmount = match[2];   // "86.49"
          estimatedFare = fareAmount;    // ⬅️ Set final value as just the amount
        }
      }


      // console.log("selectedHourlyBookingTime", selectedHourlyBookingTime);


      const domain = sessionStorage.getItem("x_company_domain");


      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickUp.coords.lat().toString(),
        longitude: pickUp.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,
        }),
        ...(bookType !== 4 && {
          // approx_fare: estimatedFare,
          approxTripFare: estimatedFare,
        }),
        // approxTripFare: drop.address !== "" ? approxTripFare : 0,
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };


      // console.log("selectedModel", selectedModel);
      // console.log("postData 1", postData);

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          if (Response.data.status >= 1) {
            setLoader2(false);

            if (dateValue) {
              setshowErrorMessage(Response.data);

              const obj2 = {
                passengerId: Response?.data?.detail?.passengerInfo?.id,
              };

              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              sessionStorage.setItem("passengerId", JSON.stringify(obj2));
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }
          }
          else {
            setAlertMsg(Response.data.message);
            setOpenAdd3(true);
            setLoader2(false);
            setshowErrorMessage(Response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  let pickupCheck = params.get("pickupplace");
  let dropCheck = params.get("dropplace");

  return (
    <Box style={{ flexGrow: 1, marginTop: "8px" }}>
      <Grid container spacing={0} flexDirection="row" alignItems="center">
        <Grid item xs={4} className={classes.formContent}>
          <Box style={{ width: "160px" }}>
            <Typography
              style={{ fontSize: "14px", fontWeight: "400", }}
              variaint="subtitle2"
            >
              Type
            </Typography>
          </Box>
        </Grid>
        <Dialog
          open={openAdd3}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose3}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose31}
              variant="contained"
              color="white"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd4}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose4}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose41}
              variant="contained"
              color="white"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openOtp}
          // onClose={handleCloseOtp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ boxShadow: "1px 1px 1px 1px" }}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ paddingTop: "6px", paddingRight: "14px" }}
          >
            <Grid
              container
              spacing={3}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item>{"Please, Enter OTP!"}</Grid>
              <Grid item>
                <CloseIcon
                  onClick={handleCloseOtp}
                  style={{
                    color: "red",
                    border: "1px solid red",
                    cursor: "pointer",
                  }}
                />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <>
              <TextField
                id="outlined-basic"
                label="OTP"
                inputProps={{ maxLength: 4 }}
                style={{ marginTop: "25px" }}
                value={val}
                onChange={handleChangeValidate}
                fullWidth
                variant="outlined"
              />
              <a
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                  color:
                    countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                  pointerEvents:
                    countDown !== null && countDown !== 0 ? "none" : "",
                  cursor:
                    countDown !== null && countDown !== 0 ? "" : "pointer",
                }}
                onClick={() => ResendOtp(pickUp.address)}
                disabled={countDown !== null && countDown !== 0 ? true : false}
              >
                Resend OTP{" "}
                {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
              </a>
            </>
          </DialogContent>
          <DialogActions>
            <>
              <Button
                onClick={() => BookTaxi(pickUp.address)}
                style={{
                  backgroundColor: companyTheme?.primaryColorCode,
                  borderRadius: "4px",
                }}
                disabled={val.length === 4 ? false : true}
                variant="contained"              >
                {loader2 ? (
                  <CircularProgress style={{ width: "30px", height: "30px", color: 'white' }} />
                ) : (
                  "Verify"
                )}
              </Button>
            </>
          </DialogActions>
        </Dialog>
        <Grid
          item
          xs={8}
          style={{ marginTop: "16px" }}
          className={classes.formContent}
        >
          <Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <div onChange={(e) => handleChangeType(e.target.value)}>
                <div className="sound-signal">
                  <input
                    type="radio"
                    value="Transfer"
                    name="transfer"
                    id="soundsignal3"
                    checked={transferStatus}
                  />
                  <label for="soundsignal3" style={{ marginRight: "12px" }}>
                    Transfer
                  </label>



                  <>
                    <input
                      type="radio"
                      value="Subscription"
                      name="bookingType"
                      id="soundsignal6"
                      checked={subscriptionStatus}
                    />
                    <label htmlFor="soundsignal6" style={{ marginRight: "12px" }}>
                      Subscription
                    </label>

                    <input
                      type="radio"
                      value="Hourly"
                      name="bookingType"
                      id="soundsignal7"
                      checked={hourlyStatus}
                    />
                    <label htmlFor="soundsignal7" style={{ marginRight: "12px" }}>
                      Hourly
                    </label>
                  </>


                </div>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box></Box>
    </Box>
  );
};

const BookButtonNew = ({
  selectedModel,
  driverDetails,
  dateValue,
  selectedPlan,
  pickUp,
  drop,
  setsearchingDriver,
  setshowErrorMessage,
  setTripID,
  bookType,
  setBookType,
  transferStatus,
  setTransferStatus,
  fullDayStatus,
  setFullDayStatus,
  halfDayStatus,
  setHalfDayStatus,
  subscriptionStatus,
  setSubscriptionStatus,
  hourlyStatus, setHourlyStatus,
  setApproxTripFare,
  fareDetails,
  activeIndex,
  guest,
  approxTripFare,
  error,
  setError,
  startDate,
  endDate,
  time,
  setStartDate,
  setEndDate,
  setTime,
  setPickup,
  setDrop,
  planBaseFare,
  selectedDays,
  selectedHourlyTime,
  subscriptionTripFare,
  twoWayPickupTime,
  distance,
  duration,
  waypoints,
  pickUp1,
  drop1,
  twoWaypoints,
  twoWayBaseFare,
  twoWayTripFare,
  selectedHourlyBookingTime,
  recurringBookingEnable,
  fareDetails1,
  companyId,
  companyTheme,
  modelHourlyFare,
  duration2,
  distance2,
  errMsg,
  setErrMsg,
  setHourlyErr
}) => {

  const [paymentValue, setPaymentValue] = useState(1);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [open, setOpen] = useState(false);

  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));
  var otp = sessionStorage.getItem("otp");
  const [loader1, setLoader1] = useState(false);

  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [openAdd3, setOpenAdd3] = React.useState(false);
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);
  const [openAdd4, setOpenAdd4] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("Something went wrong");
  const [val, setVal] = useState("");
  const [emailExistMessage, setEmailExistMessage] = useState("");
  const [newUser, setNewUser] = useState(null);

  const handleChangeType = (event) => {
    let model = fareDetails[activeIndex];
    // console.log(event.target.value);
    let bookType1 = event;
    // console.log(this);
    // console.log(bookType1);

    if (bookType1 === "FullDay") {
      setBookType(1);
      if (model) {
        setApproxTripFare(model.full_day);
      }

      setHalfDayStatus(false);
      setTransferStatus(false);
      setFullDayStatus(true);
      setSubscriptionStatus(false);
      setHalfDayStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "HalfDay") {
      setBookType(2);
      if (model) {
        setApproxTripFare(model.half_day);
      }

      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Transfer") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(true);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Subscription") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(true);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    }
    else if (bookType1 === "Hourly") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(true);
      // setRoundTripStatus(false);
    }
  };


  const handlePaymentChange = (event) => {
    setPaymentValue(event.target.value);
    // console.log(paymentValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => { }, []);

  Geocode.setApiKey(API_KEY);

  // set response language. Defaults to english.
  Geocode.setLanguage("en");

  // set response region. Its optional.
  // A Geocoding request with region=es (Spain) will return the Spanish city.
  Geocode.setRegion("ae");

  // Enable or disable logs. Its optional.
  Geocode.enableDebug();

  function getPassengerUpdate(trip_id) {
    //   // console.log("Helllllooooo", pickupLatLng.lat());

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        // console.log("savebook statusssssss--->", Response.data.status);
        //{"message":"Your booking is confirmed.","trip_id":901966,"is_first_trip":"","event_ride_count":"0","status":1,"user_key":"7e1b314f553e5981e9f11507ee08db2933befc35403cc0c0f715d7c48bde6764_61b73888b374ae141f7f51d5"}
        if (Response.data.status == 1) {
          let fareDetails = Response.data.fare_details;
          // setTripInProgress(true);
          setTripID(trip_id);
          setsearchingDriver(false);
          //setshowErrorMessage("")

          // alert(Response.data.message);
          // setshowErrorMessage(Response.data.message)
        } else {
          //   setSearchingCar(false);
          // alert(Response.data.message);
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        console.log("error Comes:", error);
      });
  }

  function validateScheduleTimes(schedule) {
    for (const [day, times] of Object.entries(schedule)) {
      const [ph, pm] = times?.pickup && times?.pickup?.split(":").map(Number);
      const [dh, dm] = times?.drop && times?.drop?.split(":").map(Number);

      const pickupMinutes = ph * 60 + pm;
      const dropMinutes = dh * 60 + dm;

      // if (pickupMinutes >= dropMinutes) {
      //   return {
      //     isValid: false,
      //     message: `On ${day}, the pickup time (${times?.pickup}) must be earlier than the drop time (${times?.drop}).`
      //   };
      // }

      if (pickupMinutes >= dropMinutes) {
        const pickupFormatted = dayjs(times?.pickup, 'HH:mm').format('hh:mm A');
        const dropFormatted = dayjs(times?.drop, 'HH:mm').format('hh:mm A');

        return {
          isValid: false,
          message: `On ${day}, the One Way Pickup time (${pickupFormatted}) must be earlier than the Two Way Pickup time (${dropFormatted}).`
        };
      }


    }

    return {
      isValid: true,
      message: "All pickup times are valid."
    };
  }



  //  console.log("selectedHourlyBookingTime", selectedHourlyBookingTime)


  // function validateScheduleTimes(schedule) {
  //   if (!schedule || typeof schedule !== "object") {
  //     return {
  //       isValid: false,
  //       message: "Schedule must be an object of day → { pickup, drop } entries."
  //     };
  //   }

  //   for (const [day, times] of Object.entries(schedule)) {
  //     // Make sure both pickup and drop exist and look like “HH:MM”
  //     console.log("testing times", times, day)
  //     if (
  //       !times ||
  //       typeof times.pickup !== "string" ||
  //       typeof times.drop !== "string" ||
  //       !times.pickup.includes(":") ||
  //       !times.drop.includes(":")
  //     ) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, expected both pickup and drop times in "HH:MM" format.`
  //       };
  //     }

  //     const [ph, pm] = times.pickup.split(":").map(Number);
  //     const [dh, dm] = times.drop.split(":").map(Number);

  //     const pickupMinutes = ph * 60 + pm;
  //     const dropMinutes = dh * 60 + dm;

  //     if (Number.isNaN(pickupMinutes) || Number.isNaN(dropMinutes)) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, could not parse pickup (“${times.pickup}”) or drop (“${times.drop}”) time.`
  //       };
  //     }

  //     if (pickupMinutes >= dropMinutes) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, pickup time (${times.pickup}) must be earlier than drop time (${times.drop}).`
  //       };
  //     }
  //   }

  //   return {
  //     isValid: true,
  //     message: "All pickup and drop times are valid."
  //   };
  // }

  const handleOtpCheck = () => {


    setErrMsg('');
    // handleClickOpenOtp();

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader1(true);


    if (
      a.firstName === "" ||
      a.email === "" ||
      a.mobileNumber === "" ||
      pickUp?.address === "" ||
      drop?.address === ""
    ) {
      setAlertMsg("All Fields Are Required");
      setLoader1(false);
      setOpenAdd3(true);
      return;
    }


    // console.log("modelHourlyFare", modelHourlyFare);


    // console.log("error", error);



    const daySlot = [
      "All",
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const dayTimeState = JSON.parse(sessionStorage.getItem("dayTimeState"));
    //  console.log("dayTimeState", dayTimeState);

    const isTimeSlotValid = () => {
      for (const dayIndex of selectedDays) {
        const dayName = daySlot[dayIndex + 1];

        if (!dayName) {
          // console.warn("Invalid day index:", dayIndex);
          return false;
        }

        if (dayTimeState && Object.keys(dayTimeState).length !== 0) {
          const dayState = dayTimeState[dayName];
          if (!dayState?.pickup) {
            return false;
          }

          if (selectedPlan?.tripType === 2 && !dayState?.drop) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    };


    // console.log("booktype", bookType);

    const validateDayTimeState = (dayTimeState, startDate, endDate, selectedDays, daySlot) => {
      if (!dayTimeState || Object.keys(dayTimeState).length === 0) {
        return { isValid: false, message: "Day slots are required" };
      }


      const validDays = [];
      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        validDays.push(
          current.toLocaleDateString("en-US", { weekday: "long" }) // e.g., "Tuesday"
        );
        current.setDate(current.getDate() + 1);
      }

      const selectedDayNames = selectedDays.map(i => daySlot[i + 1]);

      for (const dayName of selectedDayNames) {
        if (!validDays.includes(dayName)) {
          return { isValid: false, message: `${dayName} is outside your selected date range` };
        }

        // Also check pickup/drop times
        const times = dayTimeState[dayName];
        if (!times?.pickup || (times.pickup === "00:00" && times.drop === "00:00")) {
          return { isValid: false, message: `${dayName} has invalid Pickup times .TwoWay time must be greater than OneWay Time` };
        }
      }

      return { isValid: true, message: "" };
    };



    if (bookType === 3) {
      if (!isTimeSlotValid()) {
        setAlertMsg("All Fields Are Required");
        setLoader1(false);
        // setOpenAdd3(true);
        return;
      }

      const dayValidation = validateDayTimeState(dayTimeState,
        startDate,
        endDate,
        selectedDays,
        daySlot);

      // console.log("dayValidation",dayValidation);


      if (!dayValidation.isValid) {
        setErrMsg(dayValidation.message);
        // setLoader1(false);
        setLoader1(false);
        return;
      }



      if (selectedPlan?.tripType === 2 && dayTimeState && !validateScheduleTimes(dayTimeState).isValid) {
        // setAlertMsg(validateScheduleTimes(dayTimeState).message);
        // setLoader1(false);
        setAlertMsg(validateScheduleTimes(dayTimeState).message);
        setLoader1(false);
        return;
        // return;
      }


      if (
        !selectedDays ||
        !selectedPlan ||
        selectedDays.length === 0 ||
        time === "" ||
        planBaseFare === 0 ||
        (selectedPlan.tripType === 2 && twoWayPickupTime === "") ||
        (selectedPlan.tripType === 2 && pickUp1?.address === "") ||
        (selectedPlan.tripType === 2 && drop1?.address === "") ||
        (selectedPlan.type === 3 && selectedHourlyTime === "")
      ) {
        setAlertMsg("All Fields Are Required");
        setLoader1(false);
        setOpenAdd3(true);
        return;
      }
    }


    // console.log("selectedModel",selectedModel);


    if (bookType === 4) {
      if (selectedHourlyBookingTime === 0 || selectedHourlyBookingTime < 0 || selectedModel.hourly_fare < 0) {
        // console.log("if comes");
        setErrMsg("Please select hours");
        setLoader1(false);
        // setOpenAdd3(true);
        return;
      }


      if (modelHourlyFare === 0 && bookType === 4) {
        setHourlyErr(true);
        setLoader1(false);
        return;
      }

    }

    // console.log("alertMsg",alertMsg);

    let obj = {
      name: a.firstName + " " + a.lastName,
      countryCode: `+${a.countryCode}`,
      phone: a.mobileNumber,
      companyId: companyId,
      type: 1,
      subscription: bookType === 3 ? 1 : 0,
      email: a.email
    };




    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader1(false);
          setNewUser(Response.data.newUser);
          setEmailExistMessage(Response?.data?.emailExistMessage)
          sessionStorage.setItem(
            "newUser",
            JSON.stringify({ newUser: Response.data.newUser })
          );

          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

          // sessionStorage.setItem("id", Response.data.responsData._id);
          handleClickOpenOtp();
        } else if (Response.data.status === -1) {
          handleCloseOtp();
          setLoader1(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          handleCloseOtp();
          setCountDown(null);
          setLoader1(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3Success(true);
        }
      })
      .catch((error) => {
        setCountDown(null);
        console.log(error);
      });
  };

  useEffect(() => {
    if (countDown !== null && countDown !== 0) {
      const interval = setInterval(() => {
        setCountDown(countDown - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countDown]);

  const ResendOtp = () => {


    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    let obj;

    if (bookType === 3) {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1,
        email: a.email
      };
    } else {
      obj = {
        name: a.firstName + " " + a.lastName,
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 0,
        email: a.email
      };
    }

    setLoader3(true);
    // setLoader2(true);

    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader3(false);
          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

        } else if (Response.data.status === -1) {
          setLoader3(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
          setOpenAdd3(true);
        } else {
          setCountDown(null);
          setLoader3(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeValidate = (e) => {
    const regex = /^[0-9\b]+$/;
    sessionStorage.removeItem("otp");

    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }

    sessionStorage.setItem("otp", e.target.value);
  };

  const handleAddClose3 = () => {
    setOpenAdd3(false);
  };

  const handleAddCloseSuccess = () => {
    setOpenAdd3Success(false);
  };

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose31 = () => {
    // setOpenOtp(false);
    setOpenAdd3(false);
  };


  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleClickOpenOtp = () => {
    setOpenOtp(true);
    // setLoader2(true);
  };

  const handleCloseOtp = () => {
    setOpenOtp(false);
    setEmailExistMessage("");
  };


  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader2(true);

    setVal("");

    if (bookType === 3) {
      const formattedStartDate = moment(startDate).format("YYYY-MM-DD HH:mm:ss");


      const formattedEndDate = moment(endDate).format("YYYY-MM-DD HH:mm:ss");

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");

      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      // console.log(dropLocationInfo);

      // console.log("twoWayBaseFare", twoWayBaseFare);


      const postData = {
        _id: passengerId?.passengerId,
        newUser: newUser,
        motorModelId: selectedModel._id,
        otp: otp,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: pickUp.address,
          latitude: pickUp.coords.lat(),
          longitude: pickUp.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        farePerTrip: planBaseFare,
        totalFare: subscriptionTripFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        daySlot: selectedDays,
        hours: selectedHourlyTime,
        isRecurringBooking: recurringBookingEnable,
        ...(subscriptionDetailsNew?.tripType === 2 && {

          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayPickupLocationInfo: {
            address: pickUp1.address,
            latitude: pickUp1.coords.lat(),
            longitude: pickUp1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayBaseFare,
          twoWaytotalFare: twoWayTripFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };

      const domain = sessionStorage.getItem("x_company_domain");


      console.log("selectedHourlyTime", selectedHourlyTime);


      axios
        .post(
          `${BACKEND_URL}/createEnquiry?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          if (Response.data.status >= 1) {
            // console.log("res---", 1);
            setEmailExistMessage("");
            //  let fareDetails = Response.data.fare_details;
            setOpenOtp(false);
            setAlertMsg(Response.data.message);
            setshowErrorMessage(Response.data);
            setLoader2(false);
            setOpenAdd3(true);
            sessionStorage.setItem(
              "passengerInfo",
              JSON.stringify(Response?.data?.detail?.passengerInfo)
            );

            const obj2 = {
              passengerId: Response?.data?.detail?.passengerInfo?.id,
            };

            sessionStorage.setItem("passengerId", JSON.stringify(obj2));

          }
          else {
            setBookType(3);
            setshowErrorMessage(Response.data);

            if (Response.data.isVerified) {
              setOpenOtp(false);
            } else {
              setOpenOtp(true);
            }
            setAlertMsg(Response.data.message);

            setLoader2(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {


      // console.log("fareDetails1", fareDetails1)


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1];
          const fareAmount = match[2];
          estimatedFare = fareAmount;
        }
      }


      // console.log("dateValue 2", dateValue)

      const domain = sessionStorage.getItem("x_company_domain");

      //  console.log("selectedHourlyBookingTime", selectedHourlyBookingTime)

      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickUp.coords.lat().toString(),
        longitude: pickUp.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        scheduleBookType: bookType,
        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,
        }),
        ...(bookType !== 4 && {
          // approx_fare: estimatedFare,
          approxTripFare: estimatedFare,
        }),
        // approxTripFare: drop.address !== "" ? approxTripFare : 0,
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };

      // console.log("postData", postData);

      // console.log("selectedModel", selectedModel);
      // console.log("postData 2", postData);

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          // console.log('savebook statusssssss--->', Response.data.status);
          if (Response.data.status >= 1) {
            //  let fareDetails = Response.data.fare_details;
            setLoader2(false);

            // console.log('savebook statusssssss--->', Response.data);

            if (dateValue) {
              setshowErrorMessage(Response.data);



              // if (Response.data.newUser === 1) {
              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );
              // sessionStorage.setItem("passengerId", JSON.stringify(obj2));

              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }
          }
          else {
            setAlertMsg(Response.data.message);
            setshowErrorMessage(Response.data);
            setLoader2(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  let pickupCheck = params.get("pickupplace");
  let dropCheck = params.get("dropplace");


  // console.log("loader1", loader1);



  return (
    <Box style={{ flexGrow: 1, marginTop: "8px" }}>
      <Grid container spacing={0} flexDirection="row" alignItems="center">
        <Dialog
          open={openAdd3}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose3}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose31}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd3Success}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddCloseSuccess}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/greenTick.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3>{alertMsg}455</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddCloseSuccess}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd4}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose4}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose41}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openOtp}
          // onClose={handleCloseOtp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ boxShadow: "1px 1px 1px 1px" }}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ paddingTop: "6px", paddingRight: "14px" }}
          >
            <Grid
              container
              spacing={3}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item>{"Please, Enter OTP!"}</Grid>
              <Grid item>
                <CloseIcon
                  onClick={handleCloseOtp}
                  style={{
                    color: "red",
                    border: "1px solid red",
                    cursor: "pointer",
                  }}
                />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <>
              {
                emailExistMessage &&
                <Grid
                  container
                  spacing={3}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sx={{ fontSize: "14px" }}><span style={{ color: "#FFC107" }}>NOTE:</span> {emailExistMessage}</Grid>
                </Grid>
              }

              <TextField
                id="outlined-basic"
                label="OTP"
                inputProps={{ maxLength: 4 }}
                style={{ marginTop: "25px" }}
                value={val}
                onChange={handleChangeValidate}
                fullWidth
                variant="outlined"
              />
              <a
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                  color:
                    countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                  pointerEvents:
                    countDown !== null && countDown !== 0 ? "none" : "",
                  cursor:
                    countDown !== null && countDown !== 0 ? "" : "pointer",
                }}
                onClick={() => ResendOtp(pickUp.address)}
                disabled={countDown !== null && countDown !== 0 ? true : false}
              >
                Resend OTP{" "}
                {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
              </a>
            </>
          </DialogContent>
          <DialogActions>
            <>
              <Button
                onClick={() => BookTaxi(pickUp.address)}
                style={{
                  backgroundColor: companyTheme?.primaryColorCode,
                  borderRadius: "4px",
                  color: "white",
                }}
                disabled={val.length === 4 ? false : true}
                variant="contained"
              >
                {loader2 ? (
                  <CircularProgress style={{ width: "30px", height: "30px", color: "white" }} />
                ) : (
                  "Verify"
                )}
              </Button>
            </>
          </DialogActions>
        </Dialog>
      </Grid>

      <Box>
        <Box
          style={{
            padding: "0px 0px 12px 0px",
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          ></Box>
        </Box>
        {/* <Divider /> */}
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "8px",
            justifyContent: "end",
          }}
        >
          <Grid container>
            {bookType !== 3 ? (
              <Grid item xs={12}>
                <Box style={{ width: "100%", marginTop: "40px" }}>
                  {(pickUp.address || pickupCheck) &&
                    selectedModel &&
                    (getDriverByModel(driverDetails, selectedModel._id)
                      .length > 0 ||
                      dateValue != null) ? (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                      }}
                      variant="contained"
                      color="white"
                      onClick={() => handleOtpCheck()}

                    >
                      {loader1 ? (
                        <CircularProgress
                          style={{ width: "30px", height: "30px", color: "white" }}
                        />
                      ) : (
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: "14px", color: 'white' }}
                        >
                          {dateValue
                            ? "Schedule at " + dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
                            : "Request " + selectedModel.model_name}
                        </Typography>
                      )}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                        // marginTop: "8px",
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        var guetsDetailsLocal =
                          sessionStorage.getItem("guestFinal");
                        var guetsDetailsLocalNew =
                          JSON.parse(guetsDetailsLocal);
                        var a = guetsDetailsLocalNew;

                        // console.log("guetsDetailsLocal" ,guetsDetailsLocal);

                        if (!a ||
                          a.firstName === "" ||
                          a.email === "" ||
                          a.mobileNumber === "" ||
                          pickUp?.address === "" ||
                          drop?.address === "" ||
                          !selectedDays ||
                          !selectedPlan ||
                          selectedDays.length === "" ||
                          selectedDays.length === 0 ||
                          selectedHourlyTime === "" ||
                          time === "" ||
                          planBaseFare === 0 ||
                          twoWayPickupTime === "" ||
                          (selectedPlan.tripType === 2 &&
                            twoWayPickupTime <= time) ||
                          (selectedPlan.tripType === 2 &&
                            selectedHourlyTime === "") ||
                          (startDate && endDate && startDate >= endDate)
                        ) {
                          setAlertMsg("All Fields Are Required");
                          setLoader1(false);
                          setOpenAdd3(true);
                          // alert('All fields are manditory');
                        }

                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "14px", color: 'white' }}
                      >
                        {pickUp.address || pickupCheck
                          ? selectedModel
                            ? "Currently No driver available"
                            : "Select Model"
                          : "Schedule Pickup"}
                      </Typography>
                    </Button>
                  )}
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box style={{ width: "100%", marginTop: "40px" }}>
                  {(pickUp.address || pickupCheck) &&
                    selectedModel &&
                    (getDriverByModel(driverDetails, selectedModel._id)
                      .length > 0 ||
                      dateValue != null) ? (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                        color: "white"
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => handleOtpCheck()}
                      disabled={loader1}
                    >
                      {loader1 ? (
                        <CircularProgress
                          style={{ width: "30px", height: "30px", color: "white" }}
                        />
                      ) : (
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: "14px" }}
                        >
                          Submit Enquiry
                        </Typography>
                      )}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                        // marginTop: "8px",
                      }}
                      variant="contained"
                      color="primary"
                      disabled={loader1}
                      onClick={() => {
                        var guetsDetailsLocal =
                          sessionStorage.getItem("guestFinal");
                        var guetsDetailsLocalNew =
                          JSON.parse(guetsDetailsLocal);
                        var a = guetsDetailsLocalNew;

                        if (
                          a.firstName === "" ||
                          a.email === "" ||
                          a.mobileNumber === "" ||
                          pickUp?.address === "" ||
                          drop?.address === ""
                        ) {
                          setAlertMsg("All Fields Are Required");
                          setLoader1(false);
                          setOpenAdd3(true);
                          // alert('All fields are manditory');
                        }


                      }}
                    >
                      {loader1 ? (
                        <CircularProgress
                          style={{ width: "30px", height: "30px", color: "white" }}
                        />
                      ) : (
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: "14px" }}
                        >
                          {pickUp.address || pickupCheck
                            ? selectedModel
                              ? "Currently No driver available"
                              : "Select Model"
                            : "Submit Enquiry"}
                        </Typography>
                      )}
                    </Button>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};


const Message = ({ showErrorMessage, setshowErrorMessage }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  //const [showErrorMessage, setshowErrorMessage] = useState("");

  const { companyTheme } = useCompanyTheme();

  sessionStorage.setItem("showErrorMessage", JSON.stringify(showErrorMessage));
  navigate("/bookingconfirmation");

  return (
    <div className={classes.vehicleDisplayContainer}>
      <Box
        style={{
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography variant="h6">{"Swiss"}</Typography>
        </Box>
        <Box>
          <IconButton
            onClick={() => {
              setshowErrorMessage("");
              navigate("/");
              window.location.reload();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Divider />
      <Box>
        <Box
          style={{
            textAlign: "center",
            backgroundColor: "#f9fafb",
            // width: '60%',
            width: "100%",
            margin: "auto",
            borderRadius: "6px",
            marginTop: "24px",
            height: "400px",
            // boxShadow: '0px 0px 17px -12px rgba(0,0,0,0.85)',
            boxShadow: "inset rgba(0, 0, 0, 0.85) 0px 0px 17px -12px",
          }}
        >
          {showErrorMessage === "Something went wrong" ? (
            <Box>
              <InfoRounded
                style={{ width: "100px", height: "100px", color: companyTheme?.primaryColorCode }}
              />
              <Typography variant="h6"> {showErrorMessage}</Typography>
            </Box>
          ) : (
            <Box>
              <Done
                style={{ width: "100px", height: "100px", color: companyTheme?.primaryColorCode }}
              />
              <Box>
                <Typography variant="h5" style={{ color: "green" }}>
                  Booking created Success
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle1">
                  Vehicle Model: {showErrorMessage.detail.modelName}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1">
                  Passenger TripId: {showErrorMessage.detail.passengerTripId}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1">
                  Booking Time: {showErrorMessage.detail.pickupDateTime}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1">
                  Booking Type:{" "}
                  {showErrorMessage.detail.scheduleBookType === 0
                    ? "Transfer"
                    : showErrorMessage.detail.scheduleBookType === 1
                      ? "Full Day"
                      : showErrorMessage.detail.scheduleBookType === 2
                        ? "Half Day"
                        : // : showErrorMessage.detail.scheduleBookType === 3
                        // ? 'Round Trip'
                        ""}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle1">
                  Estimated Fare: {showErrorMessage.detail.approxTripFare}
                </Typography>
              </Box>
              <Box style={{ marginTop: "24px", padding: "24px", color: "red" }}>
                <Typography variant="subtitle2">
                  {showErrorMessage.detail.message}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Box style={{ textAlign: "center", marginTop: "30px" }}>
          <Button
            style={{ borderRadius: "2px", backgroundColor: companyTheme?.primaryColorCode, }}
            variant="contained"
            color="secondary"
            onClick={(e) => {
              setshowErrorMessage("");
              navigate("/");
              window.location.reload();
            }}
          >
            Go Home
          </Button>
        </Box>
      </Box>
    </div>
  );
};
function fareCalculation(distance, time, details) {
  if (details == null) {
    return 0;
  } else {
    var aprroxFare = 0;
    var nightFare = 0;
    var eveningFare = 0;
    var minFare = 0;

    var below_above_km = parseInt(details.below_above_km);
    minFare = parseFloat(details.min_fare);

    if (distance <= below_above_km) {
      aprroxFare = distance * parseFloat(details.below_km);
      aprroxFare = aprroxFare + parseFloat(details.base_fare);
    } else {
      var aboveKm = distance - below_above_km;
      aprroxFare =
        below_above_km * parseFloat(details.below_km) +
        aboveKm * parseFloat(details.above_km);
    }

    if (details.hasOwnProperty(`night_fare`)) {
      var nightFarePercentage = parseFloat(details.night_fare);
      nightFare = aprroxFare * (nightFarePercentage * 0.01);
    }

    if (details.hasOwnProperty(`evening_fare`)) {
      var eveningFarePercentage = parseFloat(details.evening_fare);
      eveningFare = aprroxFare * (eveningFarePercentage * 0.01);
    }

    if (details.hasOwnProperty(`additional_fare`)) {
      aprroxFare += parseFloat(details.additional_fare);
    }

    if (
      details.fare_calculation_type == 3 ||
      details.fare_calculation_type == 2
    ) {
      aprroxFare = aprroxFare + time * parseFloat(details.minutes_fare);
    }

    if (aprroxFare < minFare) {
      aprroxFare = minFare;
    }

    var fareObj = {
      approx_fare: aprroxFare.toFixed(2),
      night_fare: nightFare.toFixed(2),
      evening_fare: eveningFare.toFixed(2),
    };
    // console.log("fareObj", fareObj);
    return fareObj;
  }
}
const DetailPage = ({ setDetailViewIndex, selectedModel }) => {
  const classes = useStyles();

  return (
    <Box className={classes.vehicleDetailContainerGrid}>
      <Box>
        <IconButton onClick={() => setDetailViewIndex(false)}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={selectedModel.image}
          className={classes.imgClass}
          style={{ width: "150px", height: "100px" }}
          alt="fireSpot"
        />
      </Box>
      <Box
        style={{
          padding: "12px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography>{selectedModel.model_name}</Typography>
          <Typography>{selectedModel.model_size} seats</Typography>
        </Box>
        <Box>
        </Box>
      </Box>
      <Box
        style={{
          backgroundColor: "#f3f3f3",
          padding: "12px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Base fare
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Halfday
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            FullDay
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Minimum fare
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Less than {selectedModel.below_above_km} km
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Above {selectedModel.below_above_km} km
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            Free waiting mins
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.base_fare}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.half_day}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.full_day}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.min_fare}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.below_km}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            AED {selectedModel.above_km}
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ padding: "12px 0", fontWeight: "normal" }}
          >
            5 mins
          </Typography>
        </Box>
      </Box>
      <Box style={{ padding: "12px" }}>
        Additional wait time charges may apply to your trip if the driver has
        waited 5 minutes.
      </Box>
      <Box style={{ padding: "12px 12px 18px 12px" }}>
        Your fare will be the price presented before the trip or based on the
        rates below and other applicable surcharges and adjustments.
      </Box>
    </Box>
  );
};

const ConfirmedDriver = ({
  tripID,
  tripData,
  selectedModel,
  setshowErrorMessage,
  setSelectedModel,
  setTripID,
  setTripData,
  setFullLoader,
  estimatedTime,
}) => {
  const classes = useStyles();
  // let tripID = ""
  function getTripUpdate() {
    //// console.log("Helllllooooo", pickupLatLng.lat());

    //setSelectedModel(true);
    const postData = {
      trip_id: tripID,
      request_type: "0",
      drop_lat: 0,
      drop_long: 0,
      drop_location_name: "",
      passenger_id: "330",
    };

    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.com-1638361541&type=getpassenger_update&lang=en&dt=a&v=106",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        let data = Response.data;
        if (data.status >= 1) {
          setTripData(data);
          if (data.travel_status === 1) {
            setshowErrorMessage(data.message);
            setTripID("");
            setTripData(null);
          }
        } else {
          setshowErrorMessage(data.message);
        }
      })
      .catch((error) => {
        setshowErrorMessage("Something went wrong" + error.message);
      });
  }



  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }
  function CancelTrip() {
    if (tripData.travel_status !== 2 && tripData.travel_status !== 5) {
      setFullLoader(true);
      const postData = {
        passenger_log_id: tripID,
        travel_status: "4",
        remarks: "1.Cab delay",
        pay_mod_id: "2",
        creditcard_cvv: "",
        payment_mode: "1",
        payment_gateway_mode: "1",
      };

      axios
        .post(
          "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.com-1638361541&type=cancel_trip&lang=en",
          postData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "authkey ${authkey}",
            },
          }
        )
        .then((Response) => {

          if (Response.data.status >= 1) {
            setshowErrorMessage(Response.data.message);
            setTripID("");
          } else {
            setshowErrorMessage(Response.data.message);
          }
          setFullLoader(false);
        })
        .catch((error) => {
          setFullLoader(false);
          setshowErrorMessage("Something went wrong");
        });
    } else {
      alert("Sorry trip has been started. You can't cancel it");
    }
  }

  return (
    <Box className={classes.vehicleDisplayContainer}>
      {tripData ? (
        <Box>
          <Box
            style={{
              padding: "12px",
              textAlign: "center",
            }}
          >
            <Typography
              variant="subtitle2"
              style={{ color: "#53C2BD", fontSize: "18px" }}
            >
              {tripData ? tripData.message : ""}
            </Typography>
          </Box>
          <Divider />
          <Box
            style={{
              padding: "20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="h6">
                {tripData ? tripData.taxi_info.taxi_no : ""}
              </Typography>
              <Typography variant="subtitle2">
                {tripData ? tripData.taxi_info.taxi_unique : ""}
              </Typography>
              <Typography variant="subtitle2">
                {tripData ? tripData.taxi_info.taxi_manufacturer : ""}
              </Typography>
            </Box>
            <Box
              style={{
                borderRadius: "100px",
                backgroundColor: "#e4e4e4",
                width: "80px",
                height: "80px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={
                  selectedModel
                    ? selectedModel.image
                    : `/static/images/${vehicleArray[0].vehicleType}.png`
                }
                className={classes.imgClass}
                style={{
                  width: "100px",
                  height: "100px",
                }}
                alt="fireSpot"
              />
            </Box>
          </Box>
          <Box
            style={{
              padding: "8px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              alignItems: "center",
              // marginTop: '12px'
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: "#e4e4e4",
                  width: "50px",
                  height: "50px",
                  borderRadius: "100px",
                  justifyContent: "center",
                  color: "blue",
                  cursor: "pointer",
                  marginBottom: "12px",
                }}
              >
                <PhoneIcon
                  onClick={() => {
                    alert("Driver Phone: " + tripData.driver_phone);
                  }}
                />
              </Box>

              <Typography variant="subtitle2">Call driver</Typography>
            </Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  backgroundColor: "#e4e4e4",
                  width: "50px",
                  height: "50px",
                  borderRadius: "100px",
                  justifyContent: "center",
                  color: "blue",
                  cursor: "pointer",
                  marginBottom: "12px",
                }}
              >
                <HighlightOff
                  onClick={(e) => {
                    CancelTrip();
                  }}
                />
              </Box>

              <Typography variant="subtitle2">Cancel</Typography>
            </Box>
          </Box>
          <Box
            style={{
              padding: "0 12px",
            }}
          >
            <Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    margin: "0 12px",
                  }}
                >
                  <PaymentIcon />
                </Box>
                <Box
                  style={{
                    padding: "12px 0",
                    borderBottom: "1px solid lightgrey",
                    width: "100%",
                  }}
                >
                  <Typography variant="subtitle2">Payment by cash</Typography>
                  {tripData.travel_status == 9 ||
                    tripData.travel_status == 12 ||
                    tripData.travel_status == 3 ? (
                    <Typography variant="subtitle1">
                      ETA: {estimatedTime} mins
                    </Typography>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box
                  style={{
                    margin: "0 12px",
                  }}
                >
                  <LocationOnIcon />
                </Box>
                <Box
                  style={{
                    padding: "12px 0",
                    borderBottom: "1px solid lightgrey",
                    width: "100%",
                  }}
                >
                  <Typography variant="subtitle2">From </Typography>
                  <Typography variant="subtitle1">
                    {tripData ? tripData.pickup_address : ""}
                  </Typography>
                </Box>
              </Box>
              {tripData && tripData.drop_address != "" ? (
                <>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      style={{
                        margin: "0 12px",
                      }}
                    >
                      <StopIcon />
                    </Box>
                    <Box
                      style={{
                        padding: "12px 0",
                        borderBottom: "1px solid lightgrey",
                        width: "100%",
                      }}
                    >
                      <Typography variant="subtitle2">To </Typography>
                      <Typography variant="subtitle1">
                        {tripData ? tripData.drop_address : ""}
                      </Typography>
                    </Box>
                  </Box>
                </>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <ConfirmedDriverSkel />
      )}
    </Box>
  );
};


const WaitingForDriver = ({
  selectedModel,
  pickupAddress,
  dropAddress,
  dateValue,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.vehicleDisplayContainer}>
      <Box>
        <LinearProgress style={{ marginTop: "5px" }} />
      </Box>
      <Box
        style={{
          textAlign: "center",
          padding: "12px",
        }}
      >
        <Typography variant="subtitle1">
          {dateValue ? "Processing your request" : "Looking for nearby drivers"}
        </Typography>
      </Box>
      <Divider />
      <Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              margin: "0 12px",
            }}
          >
            <PaymentIcon />
          </Box>
          <Box
            style={{
              padding: "12px 0",
              borderBottom: "1px solid lightgrey",
              width: "100%",
            }}
          >
            {selectedModel ? (
              <Typography variant="subtitle2">
                AED {dropAddress !== "" ? selectedModel.fare : ""} (
                {selectedModel.model_name})
              </Typography>
            ) : (
              ""
            )}
            {/*<Typography variant="subtitle2"> ({selectedModel.model_name} AED {fareCalculation(distanceObj.value,durationObj.value,selectedModel)})</Typography>*/}
            <Typography variant="subtitle1">Cash</Typography>
          </Box>
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Box
            style={{
              margin: "0 12px",
            }}
          >
            <LocationOnIcon />
          </Box>
          <Box
            style={{
              padding: "12px 0",
              borderBottom: "1px solid lightgrey",
              width: "100%",
            }}
          >
            <Typography variant="subtitle2">From </Typography>
            <Typography variant="subtitle1">{pickupAddress}</Typography>
          </Box>
        </Box>
        {dropAddress ? (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                margin: "0 12px",
              }}
            >
              <StopIcon />
            </Box>
            <Box
              style={{
                padding: "12px 0",
                borderBottom: "1px solid lightgrey",
                width: "100%",
              }}
            >
              <Typography variant="subtitle2">To</Typography>
              <Typography variant="subtitle1">{dropAddress}</Typography>
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </div>
  );
};

const FareTooltip = ({ splitDetails }) => {
  return (
    <Tooltip
      placement="bottom"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'black',
            color: 'white',
            borderRadius: 1,
            p: 1,
            fontSize: '0.875rem',
          }
        },
        arrow: {
          sx: {
            color: 'black', // arrow color matches tooltip background
          }
        }
      }}
      title={
        <Box>
          {splitDetails?.map((group, groupIndex) => (
            <Box key={groupIndex}>
              {/* Show divider only before the second group */}
              {groupIndex === 1 && (
                <Box
                  sx={{
                    height: '1px',
                    my: 1,
                    backgroundColor: 'white',
                    width: '100%',
                  }}
                />
              )}
              {group.map((item, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  sx={{ mb: 0.5, gap: "10px" }}
                >
                  <Typography variant="body2">{item.label}</Typography>
                  <Typography variant="body2" fontWeight="bold">
                    AED {item.value}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      }
    >
      <InfoOutlinedIcon
        sx={{ fontSize: 14, ml: 0.5, cursor: 'pointer' }}
      />
    </Tooltip>
  );
};



export default function NewBookingDesign({
  pickup,
  setPickup,
  drop,
  setDrop,
  waypoints,
  setWaypoints,
  setDriverMarkerData,
  path,
  setPath,
  tripID,
  setTripID,
  setshowErrorMessage,
  showErrorMessage,
  tripData,
  setTripData,
  estimatedTime,
  vehicleModel,
  dateProps,
  timeProps,
  hourlyHire,
  distance,
  duration,
  waydrop,
  setWaydrop,
  pickup1,
  setPickup1,
  drop1,
  setDrop1,
  setPath1,
  waydrop1,
  setWaydrop1,
  onBookingDataChange,
  path1,
  companyId,
  duration2,
  distance2,
}) {

  const navigate = useNavigate();

  const [detailViewIndex, setDetailViewIndex] = useState(false);
  const [driverDetails, setDriverDetails] = useState();

  const company = sessionStorage.getItem("companyDetails");

  const { companyTheme } = useCompanyTheme();

  // console.log("company", company);


  const classes = useStyles({ companyTheme });

  const root = document.documentElement;

  root.style.setProperty('--primary-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--secondary-color', companyTheme?.secondaryColorCode);
  root.style.setProperty('--hover-color', companyTheme?.hover);
  root.style.setProperty('--input-focus-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--radio-checked-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--step-dot-color', companyTheme?.primaryColorCode);

  const [searchingCar, setSearchingCar] = useState(false);
  const [searchingDriver, setsearchingDriver] = useState(false);
  const [activeIndexSub, setActiveIndexSub] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [hasFetchedFare, setHasFetchedFare] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [distance1, setDistance1] = useState(null);
  const [laterTime, setLaterTime] = useState(0);
  let dateFirst = new Date(new Date().setMinutes(new Date().getMinutes() + laterTime));

  const [dateValue, setDateValue] = useState(new Date());

  const [isHourlyPlan, setIsHourlyPlan] = useState(false);
  const [isRecurringBooking, setIsRecurringBooking] = useState(false);
  const [recurringBookingEnable, setRecurringBookingEnable] = useState(null);
  const [errMsg, setErrMsg] = React.useState("");
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedHourlyTime, setSelectedHourlyTime] = useState("");
  const [selectedHourlyBookingTime, setSelectedHourlyBookingTime] = useState(0);
  const [subscriptionTripFare, setSubscriptionTripFare] = useState(null);

  const [twoWayTripFare, setTwoWayTripFare] = useState(null);

  const [totalDaysCount, setTotalDaysCount] = useState(null);

  const [firstWeekDaysCount, setFirstWeekDaysCount] = useState(0);
  const [inBetweenDaysCount, setInBetweenDaysCount] = useState(0);


  const [pickupTimeSlot, setPickupTimeSlot] = useState([]);
  const [dropTimeSlot, setDropTimeSlot] = useState([]);

  const [startDate, setStartDate] = useState(null);

  const [endDate, setEndDate] = useState(null);

  const defaultTime = new Date();

  const [time, setTime] = useState(dayjs().format("HH:mm"));

  const [twoWayPickupTime, setTwoWayPickupTime] = useState(
    dayjs().format("HH:mm")
  );

  useEffect(() => {
    if (
      dateProps !== null &&
      dateProps !== "" &&
      timeProps !== null &&
      timeProps !== ""
    ) {
      var DateTimeProps = dateProps + "T" + timeProps;
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else if (dateProps !== null && dateProps !== "") {
      var DateTimeProps =
        dateProps + "T" + moment().add(laterTime, "minutes").format("HH:mm");
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else if (timeProps !== null && timeProps !== "") {
      var DateTimeProps = moment().format("YYYY-MM-DD") + "T" + timeProps;
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else {
      setDateValue(moment(dateFirst).format("YYYY-MM-DD hh:mm:ss A"));
    }
  }, []);


  // console.log("company-->", companyId);


  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    email: false,
    mobileNumber: false,
    pickupType: false,
  });

  const [fareDetails, setFareDetails] = useState([]);

  const [modelList, setModelList] = useState([
    {
      "modelId": 1,
      "modelName": "SEDAN",
      "description": "Vehicle: LEXUS ES 350, INFINITI, CHEVROLET, BMW\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 7 AED\nLATER: 7 AED\n\nFare (per km): 1.9\n\nWaiting (per hour):  30 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 20\nLATER: 20\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 mins\n\n* Toll fee and waiting fare are not included in the estimated fare",

    },
    {
      "modelId": 10,
      "modelName": "XL",
      "description": "Vehicle: TOYOTA PREVIA, HONDA ODYSSEY, INFINITI QX60, KIA GRAND CARNIVAL, SUBURBAN\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 10 AED\nLATER: 10 AED\n\nFare (per km): 1.9\n\nWaiting (per hour):  30 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 20\nLATER: 20\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 23,
      "modelName": "VIP",
      "description": "Vehicle: Mercedes, Maserati, BMW\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 15\nLATER: 15\n\nFare (per km): 4\n\nWaiting (per hour):  60 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 50\nLATER: 50\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 19,
      "modelName": "VIP PLUS",
      "description": "Vehicle: Cadillac Escalade\n\nModel:2017-2019\nStarting Fare\nNOW: 15\nLATER: 15\n\nFare (per km): 4\n\nWaiting (per hour):  60 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 50\nLATER: 50\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 14,
      "modelName": "AE EXPRESS PICKUP",
      "description": "Vehicle: PICKUP (1 TON)\nModel: 2010 - 2020\n\nStarting Fare\nNOW: 10\nLATER: 10\n\nMoving (per km): 2.1\nWaiting (per hour):  60 (below 20 km/h, billed by minute)\n\nMinimum Fare \nNOW: 100\nLATER: 100",

    }
  ]);

  const [fareDetails1, setFareDetails1] = useState([]);
  const [hourlyFareSplitup, setHourlyFareSplitup] = useState([]);
  const [subscriptionFareSplitup, setSubscriptionFareSplitup] = useState([]);

  const [splitDetails, setSplitDetails] = useState([]);

  const [selectedModel, setSelectedModel] = useState(null);
  var guest = {};
  const [bookNow, setBookNow] = useState(false);

  const [fullLoader, setFullLoader] = useState(0);
  const [driverETA, setDriverETA] = useState(0);
  const [transferStatus, setTransferStatus] = useState(true);
  const [fullDayStatus, setFullDayStatus] = useState(false);
  const [halfDayStatus, setHalfDayStatus] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const [hourlyStatus, setHourlyStatus] = useState(false);
  const [bookType, setBookType] = useState(0);
  let pickUpLatLng = { lat: 0.0, lng: 0.0 };
  const [userInteracting, setUserInteracting] = useState(true);
  const [approxTripFare, setApproxTripFare] = useState(0);
  const [baseFare, setBaseFare] = useState();
  const [planBaseFare, setPlanBaseFare] = useState();
  const [modelHourlyFare, setModelHourlyFare] = useState();
  const [hourlyErr, setHourlyErr] = useState(false);

  const { setCompany } = useCompanyTheme();


  const [twoWayBaseFare, setTwoWayBaseFare] = useState();

  const [activeIndex, setActiveIndex] = useState(0);

  const [checkFalse, setCheckFalse] = useState(true);
  const [pathValue, setPathValue] = useState([]);
  const [addressJson, setAddressJson] = useState({
    addressPickup: "",
    addressDrop: "",
    distAddress: null,
    durationAddress: null,
    polylineAddress: "",
  });

  const handleWaypointChange = (index, value) => {
    const updated = [...waypoints];
    updated[index] = value; // Update the waypoint at the specific index
    setWaypoints(updated);
    setWaydrop(updated);
  };



  // console.log("selectedModel",selectedModel);

  // useEffect(() => {


  //   console.log("pickup.coords ,drop.coords");

  //   getNearestDriver(
  //     pickup.coords.lat() ? pickup.coords.lat() : "0.0",
  //     pickup.coords.lng() ? pickup.coords.lng() : "0.0",
  //     drop.coords.lat() ? drop.coords.lat() : "0.0",
  //     drop.coords.lng() ? drop.coords.lng() : "0.0",
  //     setDriverETA,
  //     0
  //   );
  // }, [pickup.coords ,drop.coords]);


  const hasFetchedConfig = useRef(false);
  const dateValRef = useRef(dateValue);
  useEffect(() => {
    dateValRef.current = dateValue;
  }, [dateValue]);

  // 1) Fetch once on mount
  useEffect(() => {

    const obj = {
      // domainName: window.location.hostname,
      domainName: "swisswebbooker.limor.us",
    }


    axios
      .post(`${BACKEND_URL}/getCompanyInfo?fromWebBooker=1`, obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        })
      .then((response) => {
        if (response?.data?.status === 1) {
          // window.location.reload();
          setCompany(response.data.responseData);
          // console.log("companyDetails", companyDetails)

        } else {
          setLaterTime(30);
        }
      })
      .catch((error) => {
        console.error(error);
        setLaterTime(30);
      });

    // axios
    //   .get(`${BACKEND_URL}/getCoreConfig?fromWebBooker=1`, {
    //     headers: { Authorization: `Bearer ${ANON_KEY}` }
    //   })
    //   .then((response) => {
    //     if (response?.data?.status === 1) {
    //       const bufferTime = response.data.details.schedule_booking_buffer_time_mins ?? 30;
    //       setLaterTime(bufferTime);
    //       setDateValue(
    //         moment()
    //           .add(bufferTime, 'minutes')
    //           .format('YYYY-MM-DD hh:mm:ss A')
    //       );
    //     } else {
    //       setLaterTime(30);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     setLaterTime(30);
    //   });
  }, []);

  useEffect(() => {

    // console.log("distance",distance);

    if (distance1 !== distance) {
      setDistance1(distance)
    }
  }, [distance]);





  useEffect(() => {
    if (
      pickup.coords.lat() !== 0 &&
      pickup.coords.lng() !== 0 &&
      drop.coords.lat() !== 0 &&
      drop.coords.lng() !== 0 &&
      selectedModel &&
      path &&
      distance1 !== distance
    ) {
      // const obj = {
      //   pickupLatitude: pickUp.coords.lat(),
      //   pickupLongitude: pickUp.coords.lng(),
      //   dropLatitude: drop.coords.lat(),
      //   dropLongitude: drop.coords.lng(),
      //   type: 2,
      // };


      // console.log("distance", distance);

      // console.log("selectedModel", selectedModel);

      const obj = {
        "corporate_id": 0,
        "pickup_latitude": pickup.coords.lat(),
        "pickup_longitude": pickup.coords.lng(),
        "drop_latitude": drop.coords.lat(),
        "drop_longitude": drop.coords.lng(),
        "company_id": companyId,
        "zone_fare_applied": 0,
        "distance": distance,
        "model_id": selectedModel?._id || 0,
        "overview_polyline": path
      }

      console.log("called 1");

      axios
        .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}` }
          })
        .then((response) => {
          if (response.data.status === 1) {
            const fareDetailsObj = response.data.details?.carMakeFare;
            setFareDetails1(fareDetailsObj);
            setPlanBaseFare(fareDetailsObj.fare);
            setModelHourlyFare(fareDetailsObj.hourly_fare);


            if (fareDetailsObj.hourly_fare <= 0 && bookType === 4) {
              setHourlyErr(true);
            } else {
              setHourlyErr(false);
            }

            setSearchingCar(false);

          } else {
            // Handle error: show error message if needed
            // setshowErrorMessage(response.data.message);
          }
        })
        .catch((error) => {
          // Handle error: show error message if needed
          // setshowErrorMessage("Something went wrong");
        });
    }
    else {
      setSelectedHourlyBookingTime(0)
    }

  }, [pickup.coords, drop.coords, distance, path, selectedModel]);


  useEffect(() => {
    if (
      pickup.coords.lat() !== 0 &&
      pickup.coords.lng() !== 0 &&
      drop.coords.lat() !== 0 &&
      drop.coords.lng() !== 0 &&
      selectedModel &&
      path &&
      distance1
    ) {
      // const obj = {
      //   pickupLatitude: pickUp.coords.lat(),
      //   pickupLongitude: pickUp.coords.lng(),
      //   dropLatitude: drop.coords.lat(),
      //   dropLongitude: drop.coords.lng(),
      //   type: 2,
      // };


      // console.log("distance", distance);


      const obj = {
        "corporate_id": 0,
        "pickup_latitude": pickup.coords.lat(),
        "pickup_longitude": pickup.coords.lng(),
        "drop_latitude": drop.coords.lat(),
        "drop_longitude": drop.coords.lng(),
        "company_id": companyId,
        "zone_fare_applied": 0,
        "distance": distance1,
        "model_id": selectedModel?._id || 0,
        "overview_polyline": path
      }

      console.log("called 2");

      axios
        .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}` }
          })
        .then((response) => {

          if (response.data.status === 1) {
            const fareDetailsObj = response.data.details?.carMakeFare;
            setFareDetails1(fareDetailsObj);
            setPlanBaseFare(fareDetailsObj.fare);
            setModelHourlyFare(fareDetailsObj.hourly_fare);

            if (fareDetailsObj.hourly_fare <= 0 && bookType === 4) {
              setHourlyErr(true);
            } else {
              setHourlyErr(false);
            }

            setSearchingCar(false);

          } else {
            // Handle error: show error message if needed
            // setshowErrorMessage(response.data.message);
          }
        })
        .catch((error) => {
          // Handle error: show error message if needed
          // setshowErrorMessage("Something went wrong");
        });
    }
  }, [selectedModel]);


  useEffect(() => {
    if (hourlyHire !== null) {
      if (hourlyHire <= 12) {
        setBookType(2);

        setFullDayStatus(false);
        setTransferStatus(false);
        setHalfDayStatus(true);
      } else {
        setBookType(1);

        setHalfDayStatus(false);
        setTransferStatus(false);
        setFullDayStatus(true);
      }
    }
  }, []);

  useEffect(() => {
    if (hourlyHire !== null) {
      if (hourlyHire <= 12) {
        if (fareDetails[activeIndex]) {
          setBookType(2);

          setApproxTripFare(fareDetails[activeIndex].half_day);

          setFullDayStatus(false);
          setTransferStatus(false);
          setHalfDayStatus(true);
        }
      } else {
        if (fareDetails[activeIndex]) {
          setBookType(1);

          setApproxTripFare(fareDetails[activeIndex].full_day);

          setHalfDayStatus(false);
          setTransferStatus(false);
          setFullDayStatus(true);
        }
      }
    }
  }, [fareDetails]);




  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  //naga
  // useEffect(() => {


  //   // console.log("pickup");

  //   if (pickup) {
  //     pickUpLatLng = pickup.coords;
  //     setCheckFalse(true);
  //     setSearchingCar(true);
  //     if (
  //       pickup.address !== "" &&
  //       addressJson.addressPickup !== pickup.address
  //     ) {
  //       // setDirectionRestric(1);
  //       setAddressJson({ ...addressJson, ["addressPickup"]: pickup.address });
  //       getNearestDriver(
  //         pickUpLatLng.lat() ? pickUpLatLng.lat() : "0.0",
  //         pickUpLatLng.lng() ? pickUpLatLng.lng() : "0.0",
  //         drop.coords.lat() ? drop.coords.lat() : "0.0",
  //         drop.coords.lng() ? drop.coords.lng() : "0.0",
  //         setDriverETA,
  //         1
  //       );

  //       // console.log('pickup', pickup.address, typeof pickup.address);
  //     } else {
  //       setAddressJson({ ...addressJson, ["addressPickup"]: pickup.address });
  //       getNearestDriver(
  //         pickUpLatLng.lat() ? pickUpLatLng.lat() : "0.0",
  //         pickUpLatLng.lng() ? pickUpLatLng.lng() : "0.0",
  //         drop.coords.lat() ? drop.coords.lat() : "0.0",
  //         drop.coords.lng() ? drop.coords.lng() : "0.0",
  //         setDriverETA,
  //         1
  //       );
  //     }
  //   }
  // }, [pickup]);

  const modelFareCalled = useRef(false);

  useEffect(() => {
    if (!pickup) return;

    const pickupLat = pickup.coords?.lat();
    const pickupLng = pickup.coords?.lng();
    const dropLat = drop?.coords?.lat();
    const dropLng = drop?.coords?.lng();

    // ✅ Case 1: all values available → call getFare
    if (pickupLat && pickupLng && dropLat && dropLng && path && distance && selectedModel) {
      getNearestDriver(
        pickupLat,
        pickupLng,
        dropLat,
        dropLng,
        setDriverETA,
        1,
        path,
        distance,
        selectedModel
      );
    }
    // ✅ Case 2: fallback → only call /modelFareDetails ONCE
    else if (!modelFareCalled.current) {
      getNearestDriver(
        pickupLat || "0.0",
        pickupLng || "0.0",
        dropLat || "0.0",
        dropLng || "0.0",
        setDriverETA,
        1
      );
      modelFareCalled.current = true; // prevent multiple calls
    }
  }, [pickup, drop, path, distance, selectedModel]);


  // console.log("selectedModel", selectedModel);

  // console.log("bookType", bookType)

  // useEffect(() => {

  //   if (onBookingDataChange) {
  //     onBookingDataChange({
  //       fareDetails: fareDetails1,
  //       selectedModel: selectedModel,
  //       bookType: bookType,
  //       hourlyFareSplitup: hourlyFareSplitup,
  //     });
  //   }

  // }, [onBookingDataChange, fareDetails1, selectedModel, bookType, hourlyFareSplitup]);


  console.log("totalDaysCount", totalDaysCount);


  useEffect(() => {
    if (onBookingDataChange) {
      const payload = {
        fareDetails: fareDetails1,
        selectedModel,
        bookType,
        ...(bookType === 4 && selectedHourlyBookingTime !== null && selectedHourlyBookingTime !== undefined
          ? { hourlyFareSplitup }
          : {}),
        ...(bookType === 3 && subscriptionTripFare && subscriptionTripFare !== null && totalDaysCount && totalDaysCount !== 0 && planBaseFare && planBaseFare !== 0
          ? {
            subscriptionFareSplitup
          }
          : {}),

      };

      onBookingDataChange(payload);
    }
  }, [
    onBookingDataChange,
    fareDetails1,
    selectedModel,
    bookType,
    hourlyFareSplitup,
    selectedHourlyBookingTime,
    subscriptionTripFare,
    twoWayTripFare,
    totalDaysCount,
    subscriptionFareSplitup,
    planBaseFare
  ]);


  // console.log("planBaseFare",planBaseFare);
  // console.log("totalDaysCount",totalDaysCount);
  // console.log("twoWayBaseFare",twoWayBaseFare);



  // useEffect(() => {
  //   if (
  //     bookType === 4 &&
  //     fareDetails.length > 0 &&
  //     distance &&
  //     distance > 0 &&
  //     selectedHourlyBookingTime != null
  //   ) {
  //     const updatedFareDetails = fareDetails.map(item => {
  //       const baseFare = item.hourly_fare || 0;
  //       const distanceFare = baseFare * selectedHourlyBookingTime;

  //       const formatCurrency = (value) =>
  //         `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

  //       const formatDistance = (value) =>
  //         `${Number(value).toFixed(2).replace(/\.00$/, '')} km`;

  //       return {
  //         ...item,
  //         split_up: [[
  //           {
  //             key: 'baseFare',
  //             formatted_key: 'Fare Per Hour',
  //             value: formatCurrency(baseFare),
  //           },
  //           {
  //             key: 'duration',
  //             formatted_key: 'Duration',
  //             value: `${selectedHourlyBookingTime} Hrs`,
  //           },
  //           {
  //             key: 'distance',
  //             formatted_key: 'Distance',
  //             value: formatDistance(distance),
  //           },
  //           {
  //             key: 'distanceFare',
  //             formatted_key: 'Distance Fare',
  //             value: formatCurrency(distanceFare),
  //           },
  //         ]]
  //       };
  //     });

  //     setHourlyFareSplitup(updatedFareDetails);
  //   }
  // }, [fareDetails, bookType, distance, selectedHourlyBookingTime]);

  useEffect(() => {
    if (
      bookType === 4 &&
      fareDetails1 &&
      distance &&
      distance > 0 &&
      selectedHourlyBookingTime != null
    ) {
      const baseFare = fareDetails1.hourly_fare || 0;
      const distanceFare = baseFare * selectedHourlyBookingTime;

      const formatCurrency = (value) =>
        `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

      const formatDistance = (value) =>
        `${Number(value).toFixed(2).replace(/\.00$/, '')} km`;

      const updatedFareDetails = {
        ...fareDetails1,
        split_up: [[
          {
            key: 'baseFare',
            formatted_key: 'Fare Per Hour',
            value: formatCurrency(baseFare),
          },
          {
            key: 'duration',
            formatted_key: 'Duration',
            value: `${selectedHourlyBookingTime} Hrs`,
          },
          {
            key: 'distance',
            formatted_key: 'Distance',
            value: formatDistance(distance),
          },
          {
            key: 'distanceFare',
            formatted_key: 'Distance Fare',
            value: formatCurrency(distanceFare),
          },
        ]]
      };

      setHourlyFareSplitup(updatedFareDetails);
    }
  }, [fareDetails1, bookType, distance, selectedHourlyBookingTime]);



  // console.log("fareDetails", fareDetails);
  // console.log("fareDetails1", fareDetails1);


  useEffect(() => {
    if (
      bookType === 3 &&
      subscriptionTripFare != null &&
      totalDaysCount !== 0 &&
      planBaseFare !== ''
    ) {
      const calculatedFare = totalDaysCount * planBaseFare;
      const weekFare = firstWeekDaysCount * planBaseFare;

      const twoWayWeekFare = firstWeekDaysCount * twoWayBaseFare;

      const formatCurrency = (value) =>
        `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

      const isTwoWayEmptyOrZero =
        !twoWayTripFare || Number(twoWayTripFare) === 0;

      const splitUp = [
        [
          {
            key: 'baseFare',
            formatted_key: 'Base Fare',
          },

          {
            key: 'oneWayFare',
            formatted_key: 'One Way',
            value: formatCurrency(planBaseFare),
          },

          ...(!isTwoWayEmptyOrZero
            ? [
              {
                key: 'twoWayBaseFare',
                formatted_key: 'Two Way',
                value: formatCurrency(twoWayBaseFare),
              },
            ]
            : []),
        ],
        [{
          key: 'totalDaysCount',
          formatted_key: 'Total Days',
          value: firstWeekDaysCount,
        },

        ],
        [
          ...(inBetweenDaysCount > 7
            ? [
              {
                key: 'weekFare',
                formatted_key: 'Fare Per Week',
              },
            ]
            : []),

          {
            key: 'distanceFare',
            formatted_key: 'One Way Fare',
            value: formatCurrency(weekFare),
          },

          ...(!isTwoWayEmptyOrZero
            ? [
              {
                key: 'twoWayTripFare',
                formatted_key: 'Two Way Fare',
                value: formatCurrency(twoWayWeekFare),
              },
            ]
            : []),]
      ];


      setSubscriptionFareSplitup(splitUp);



    }
  }, [
    bookType,
    subscriptionTripFare,
    totalDaysCount,
    planBaseFare,
    twoWayTripFare,
    firstWeekDaysCount,
    inBetweenDaysCount,
    twoWayBaseFare
  ]);




  // console.log("firstWeekDaysCount", firstWeekDaysCount);

  // console.log("pickup.coords.lat() !== '' && drop.coords.lat() ", pickup.coords.lat() , drop.coords.lat() );


  useEffect(() => {
    if (checkFalse) {
      let model = fareDetails[activeIndex];
      if (model) {
        setActiveIndex(activeIndex);
        // var obj = {
        //   modelId: model.modelId,
        //   modelName: model.modelName,
        //   fare: model.fare,
        //   description: model.description,
        //   image: `/static/images/${vehicleArray[activeIndex].vehicleType}.png`,
        // };
        // setSelectedModel(obj);
        const matchingFare = fareDetails.find(
          (detail) => detail.modelId === model.modelId
        );
        setSelectedModel(matchingFare);
        setModelCat(matchingFare?.car_make)

        if (matchingFare) {
          setPlanBaseFare(matchingFare.fare);
        }

        // if (bookType === 0) {
        //   setApproxTripFare(obj.fare);
        // } else if (bookType === 1) {
        //   setApproxTripFare(obj.full_day);
        // } else if (bookType === 2) {
        //   setApproxTripFare(obj.half_day);
        // } else if (bookType === 3) {
        //   setApproxTripFare(obj.fare);
        // }
      }
    }
  }, [fareDetails]);


  useEffect(() => {
    if (vehicleModel !== null && vehicleModel !== "") {
      setActiveIndex(0);
      // setModelCat(TaxiModelArray[0].toString());
      // TaxiModelArray.map((item, index) => {
      //   if (item.includes(vehicleModel)) {
      //     setActiveIndex(index);
      //     setModelCat(TaxiModelArray[index].toString());
      //   }
      // });
    }
  }, []);

  const API_KEY = process.env.REACT_APP_CURRENT_API_KEY;

  const [country, setCountry] = useState("us");
  const { ref: materialRef } = usePlacesWidget({
    apiKey: API_KEY,
    inputAutocompleteValue: "country",
    options: {
      componentRestrictions: {
        country,
      },
    },
  });


  // function getNearestDriver(
  //   pickupLat,
  //   pickupLng,
  //   dropLat,
  //   dropLng,
  //   setDriverETA,
  //   checkDirection,
  //   path,
  //   distance,
  //   selectedModel

  // ) {


  //   let obj;

  //   if (
  //     pickupLat.toString() !== "" &&
  //     pickupLng.toString() !== "" &&
  //     dropLat.toString() !== "0.0" &&
  //     dropLat.toString() !== "0" &&
  //     dropLng.toString() !== "0.0" &&
  //     dropLng.toString() !== "0" &&
  //     path &&
  //     distance && selectedModel &&
  //     selectedModel?.model_id !== '' &&
  //     path &&
  //     distance
  //   ) {
  //     // obj = {
  //     //   pickupLatitude: pickupLat,
  //     //   pickupLongitude: pickupLng,
  //     //   dropLatitude: dropLat,
  //     //   dropLongitude: dropLng,
  //     //   type: 2,
  //     // };

  //     //  console.log("distance", distance);

  //     console.log("selectedModel", selectedModel);



  //     const obj = {
  //       "corporate_id": 0,
  //       "pickup_latitude": pickupLat,
  //       "pickup_longitude": pickupLng,
  //       "drop_latitude": dropLat,
  //       "drop_longitude": dropLng,
  //       "company_id": companyId,
  //       "zone_fare_applied": 0,
  //       "distance": distance,
  //       "model_id": selectedModel?._id || 0,
  //       "overview_polyline": path
  //     }


  //     // console.log("distance",distance);
  //     // console.log("route",obj);



  //     console.log("called 3");

  //     axios
  //       .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj,
  //         {
  //           headers: { Authorization: `Bearer ${ANON_KEY}` }
  //         })
  //       .then((Response) => {

  //         if (Response.data.status === 1) {
  //           let fareDetailsObj = Response.data.details?.carMakeFare;
  //           setFareDetails1(fareDetailsObj);
  //           setPlanBaseFare(fareDetailsObj.fare);
  //           setModelHourlyFare(fareDetailsObj.hourly_fare);


  //           setSearchingCar(false);
  //         } else {
  //           // setshowErrorMessage(Response.data.message);
  //         }
  //       })
  //       .catch((error) => {
  //         // setshowErrorMessage("Something went wrong");
  //         console.log(error);
  //       });
  //   } else {


  //     const companyId = Number(sessionStorage.getItem('companyId'));


  //     // console.log("companyId", companyId);


  //     obj = {
  //       type: 1,
  //       company_id: companyId
  //     };


  //     axios

  //       .post(`${ADMIN_BACKEND_URL}/modelFareDetails?fromWebBooker=1`, obj,
  //         {
  //           headers: { Authorization: `Bearer ${ANON_KEY}` }
  //         })
  //       .then((Response) => {

  //         if (Response.data.status === 1) {
  //           let fareDetailsObj = Response.data.responseData;
  //           setFareDetails(fareDetailsObj);
  //           // }

  //           setSearchingCar(false);
  //         } else {
  //           // setshowErrorMessage(Response.data.message);
  //         }
  //       })
  //       .catch((error) => {
  //         // setshowErrorMessage("Something went wrong");
  //         console.log(error);
  //       });
  //   }
  // }
  function getNearestDriver(
    pickupLat,
    pickupLng,
    dropLat,
    dropLng,
    setDriverETA,
    checkDirection,
    path = null,
    distance = null,
    selectedModel = null
  ) {
    const companyId = Number(sessionStorage.getItem("companyId")) || swiss_id;

    // ✅ check if full details are available for fare API

    // console.log("companyId",companyId)

    const canGetFare =
      pickupLat &&
      pickupLng &&
      dropLat &&
      dropLng &&
      path &&
      distance &&
      selectedModel?.model_id;

    if (canGetFare) {
      const obj = {
        corporate_id: 0,
        pickup_latitude: pickupLat,
        pickup_longitude: pickupLng,
        drop_latitude: dropLat,
        drop_longitude: dropLng,
        company_id: companyId,
        zone_fare_applied: 0,
        distance,
        model_id: selectedModel?._id || 0,
        overview_polyline: path,
        // ...(bookType === 3
        //   ? {
        //     isSubscriptionEnquiry: 1,
        //     subscription_id: selectedPlan?._id,
        //   }
        //   : {}),
      };

      // console.log("🚕 Calling /getFare", obj);

      axios
        .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj, {
          headers: { Authorization: `Bearer ${ANON_KEY}` },
        })
        .then((Response) => {
          if (Response.data.status === 1) {
            let fareDetailsObj = Response.data.details?.carMakeFare;
            setFareDetails1(fareDetailsObj);
            setPlanBaseFare(fareDetailsObj.fare);
            setModelHourlyFare(fareDetailsObj.hourly_fare);

            if (fareDetailsObj.hourly_fare <= 0 && bookType === 4) {
              setHourlyErr(true);
            } else {
              setHourlyErr(false);
            }

            setSearchingCar(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // ✅ fallback → only companyId known
      const obj = { type: 1, company_id: companyId };



      axios
        .post(`${ADMIN_BACKEND_URL}/modelFareDetails?fromWebBooker=1`, obj, {
          headers: { Authorization: `Bearer ${ANON_KEY}` },
        })
        .then((Response) => {
          if (Response.data.status === 1) {
            let fareDetailsObj = Response.data.responseData;
            setFareDetails(fareDetailsObj);
            setSearchingCar(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  window.FontAwesomeConfig = {
    searchPseudoElements: true,
  };

  const ExtraForm = (props) => {
    const ref0 = useRef();
    const location = useLocation();

    const params = new URLSearchParams(location.search);


    // console.log("modelCat", modelCat);

    const [dummy, setDummy] = useState({
      firstName: params.get("name") ? params.get("name") : "",
      lastName: params.get("name") ? params.get("name") : "",
      email: params.get("email") ? params.get("email") : "",
      countryCode: "971",
      mobileNumber: params.get("mobile_number")
        ? params.get("mobile_number")
        : "",
      profileImage: "",
    });

    const [error, setError] = useState({
      firstName: false,
      lastName: false,
      email: false,
      mobileNumber: false,
      pickupType: false,
    });
    const [countryCodeTemp, setCountryCodeTemp] = useState({
      code: "AE",
      phone: "971",
    });
    const [phoneCheck, setPhoneCheck] = useState(null);
    const [sessionVl, setSessionVl] = useState(null);
    const [sessionVl1, setSessionVl1] = useState(null);

    useEffect(() => {
      const items = JSON.parse(sessionStorage.getItem("passengerInfo"));

      // console.log("items",items);

      const items1 = JSON.parse(sessionStorage.getItem("passengerId"));
      // console.log("items 1",items1 );
      setSessionVl1(items1);
      setSessionVl(items);
      if (items !== null) {
        setDummy({
          ...dummy,
          firstName: items.firstName,
          lastName: items.lastName,
          email: items.email,
          countryCode: items.countryCode,
          mobileNumber: items.phone,
          profileImage: items.profileImage,
        });
        setCountryCodeTemp({
          ...countryCodeTemp,
          ["phone"]: items.countryCode,
        });
      }
    }, []);

    var countryCodeDum = {};

    const handleInputChange = (e, otpField, code) => {
      if (e === "countryCode") {
        setDummy({ ...dummy, [e]: otpField });
        setCountryCodeTemp({ code: code, phone: otpField });
      } else {
        let { name, value } = e.target;

        setDummy({ ...dummy, [name]: value });

        setError((prev) => ({
          ...prev,
          [name]: value.trim() === ""
        }));

      }
    };

    useEffect(() => {
      if (dummy.firstName !== "") {
        sessionStorage.setItem("guestFinal", JSON.stringify(dummy));
        const obj = {
          firstName: dummy.firstName,
          lastName: dummy.lastName,
          email: dummy.email,
          countryCode: dummy.countryCode,
          phone: dummy.mobileNumber,
          profileImage: dummy.profileImage,
        };

        sessionStorage.setItem("passengerInfo", JSON.stringify(obj));
        setCountryCodeTemp({
          ...countryCodeTemp,
          ["phone"]: dummy.countryCode,
        });
      }
    }, [dummy]);

    useEffect(() => {
      var guetsDetailsLocal = sessionStorage.getItem("passengerInfo");
      var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
      if (pickup.address !== "") {
        var a = guetsDetailsLocalNew;
        if (a) {
          setDummy({
            ...dummy,
            firstName: a.firstName,
            lastName: a.lastName,
            email: a.email,
            countryCode: a.countryCode,
            mobileNumber: a.phone,
            profileImage: a.profileImage,
          });
        }
      }
    }, [pickup]);


    window.addEventListener("load", (event) => {
      if (dummy.firstName === "") {
        sessionStorage.setItem("guestFinal", JSON.stringify(dummy));
      } else {
        sessionStorage.removeItem("guestFinal");
      }
    });


    function countryToFlag(isoCode) {
      return typeof String.fromCodePoint !== "undefined"
        ? isoCode
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(char.charCodeAt(0) + 127397)
          )
        : isoCode;
    }

    const handlePhoneCheck = () => {
      setPhoneCheck("If you want change phone number, please logout!");
    };

    const handlePhoneCheck1 = () => {
      setPhoneCheck("");
    };

    useEffect(() => {
      const items = JSON.parse(sessionStorage.getItem("passengerInfo"));
      const items1 = JSON.parse(sessionStorage.getItem("passengerId"));
      setSessionVl1(items1);
      setSessionVl(items);
      if (items !== null) {
        setDummy({
          ...dummy,
          firstName: items.firstName,
          lastName: items.lastName,
          email: items.email,
          countryCode: items.countryCode,
          mobileNumber: items.phone,
          profileImage: items.profileImage,
        });
        setCountryCodeTemp({
          ...countryCodeTemp,
          phone: items.countryCode,
        });
      }
    }, []);
    return (
      <>

        {/* <Box style={{ flexGrow: 1, marginTop: "12px" }}>
          <Grid container spacing={1} alignItems="center"> */}
        {/* {searchingCar ? (
              <SearchModel />
            ) : ( */}
        <VehicleDisplay
          setDetailViewIndex={setDetailViewIndex}
          fareDetails={fareDetails}
          fareDetails1={fareDetails1}
          modelList={modelList}
          driverDetails={driverDetails}
          setSelectedModel={setSelectedModel}
          setDriverMarkerData={setDriverMarkerData}
          driverETA={driverETA}
          bookType={bookType}
          pickUp={pickup}
          selectedModel={selectedModel}
          drop={drop}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
          setApproxTripFare={setApproxTripFare}
          setModelCat={setModelCat}
          modelCat={modelCat}
          baseFare={baseFare}
          setBaseFare={setBaseFare}
          planBaseFare={planBaseFare}
          setPlanBaseFare={setPlanBaseFare}
          setTwoWayBaseFare={setTwoWayBaseFare}
          twoWayBaseFare={twoWayBaseFare}
          splitDetails={splitDetails}
          companyId={companyId}
          companyTheme={companyTheme}
          hourlyErr={hourlyErr}
        />
        {/* )} */}

        <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
          <Grid container spacing={1} alignItems="center" marginTop="8px">


            {/* <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>

                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                   Name
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.name}
                variant="outlined"
                type="text"
                placeholder="Name"
                className="name"
                name="name"
                value={dummy.name !== "" ? dummy.name : ""}
                size="small"
                fullWidth
                onChange={(e) => handleInputChange(e)}
              />
            </Grid> */}


            {/* First Name */}
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }} variant="subtitle2">
                  First Name
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.firstName}
                helperText={error.firstName ? "Please enter a valid first name" : ""}
                variant="outlined"
                type="text"
                placeholder="First Name"
                className="firstName"
                name="firstName"
                value={dummy.firstName || ""}
                size="small"
                fullWidth
                onChange={handleInputChange}
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }} variant="subtitle2">
                  Last Name
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.lastName}
                helperText={error.lastName ? "Please enter a valid last name" : ""}
                variant="outlined"
                type="text"
                placeholder="Last Name"
                className="lastName"
                name="lastName"
                value={dummy.lastName || ""}
                size="small"
                fullWidth
                onChange={handleInputChange}
              />
            </Grid>




            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                  Email
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.email}
                helperText={error.email ? "Please enter a valid email" : ""}
                variant="outlined"
                type={"email"}
                name="email"
                className="email"
                placeholder="Email"
                size="small"
                fullWidth
                value={dummy.email}
                onInput={
                  (e) =>
                  (e.target.value = e.target.value
                    .replace(/\s/g, "")
                    .slice(0, 50))
                }
                onChange={(e) => handleInputChange(e)}
              />
            </Grid>
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                {" "}
                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                  Mobile Number
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <Box
                id="countryCode"
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
              >
                <Autocomplete
                  style={{ width: "30%" }}
                  defaultValue={countryCodeTemp}
                  // value={countries.find(country => country.phone === countryCodeTemp)}
                  value={countries.find(
                    (country) => country.phone === countryCodeTemp.phone
                  )}
                  name="countryCode"
                  id="countryCode"
                  ref={ref0}
                  // open={true}
                  disabled={sessionVl1 !== null ? true : false}
                  onChange={(e, newValue) =>
                    handleInputChange(
                      ref0.current.getAttribute("name"),
                      newValue.phone,
                      newValue.code
                    )
                  }
                  // onChange={(e, newValue) => // console.log(newValue)}
                  freeSolo
                  disableClearable="true"
                  options={countries}
                  classes={{
                    option: classes.option,
                    paper: classes.countryCode,
                    inputRoot: classes.inputRoot,
                    input: classes.input,
                  }}
                  className={classes.mobileCountry}
                  autoHighlight
                  getOptionLabel={(option) => `${option.code}+${option.phone}`}
                  renderOption={(option) => (
                    <React.Fragment>
                      <span>{countryToFlag(option.code)}</span>
                      {option.label} ({option.code}) +{option.phone}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Code"
                      onClick={(params) => (params.target.value = "")}
                      // label="Choose a country"
                      className={classes.mobileCountry}
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                <Tooltip title={sessionVl1 !== null ? phoneCheck : ""}>
                  <TextField
                    style={{ width: "100%" }}
                    id="standard-basic"
                    error={error.mobileNumber}
                    helperText={error.mobileNumber ? "Please enter a valid mobile" : ""}
                    type={"tel"}
                    onInput={(e) => {
                      let inputValue = e.target.value;

                      // Remove non-numeric characters
                      inputValue = inputValue.replace(/[^0-9]/g, "");

                      // Remove leading zero if it's the first character
                      if (
                        inputValue.length > 0 &&
                        inputValue.charAt(0) === "0"
                      ) {
                        inputValue = inputValue.slice(1);
                      }

                      // Limit the input to 10 characters
                      inputValue = inputValue.slice(0, 10);

                      // Update the input value
                      e.target.value = inputValue;
                    }}
                    variant="outlined"
                    pattern="[0-9]"
                    onMouseEnter={() => handlePhoneCheck()}
                    onMouseLeave={() => handlePhoneCheck1()}
                    className="mobileNum"
                    size="small"
                    disabled={sessionVl1 !== null ? true : false}
                    inputProps={{ maxLength: 11 }}
                    // value={props.apiData.mobileNumber}
                    name="mobileNumber"
                    value={dummy.mobileNumber}
                    onChange={(e) => handleInputChange(e)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* <PhoneAndroidIcon style={{ color: companyTheme?.primaryColorCode }} /> */}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* </Grid>
        </Box> */}
      </>
    );
  };

  const AddressSearchBar = ({ setDateValue }) => {
    const [waydrop, setWaydrop] = useState([]);

    const handleAddDrop = () => {
      const newPoint = { location: {} };
      setWaypoints([...waypoints, newPoint]);
      setWaydrop([...waypoints, newPoint]);
    };

    const handleRemoveDrop = (index) => {
      const updatedWayPath = [...wayPath];
      updatedWayPath.splice(index, 1);
      setWayPath(updatedWayPath);

      const updatedWaypoints = [...waypoints];
      updatedWaypoints.splice(index, 1);
      setWaypoints(updatedWaypoints);
      setWaydrop(updatedWaypoints);
    };


    // console.log("waypoints",waypoints);


    return (
      <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
              Pickup & Drop
            </Typography>
          </Grid>

          <Grid item xs={8} className={classes.formContent}>
            <ol className="c-stepper" style={{ padding: 0 }}>
              {/* Pickup Location */}
              <li className="c-stepper__item">
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto
                      className="pickup"
                      type="pickup"
                      drop={drop}
                      pickup={pickup}
                      setPickup={setPickup}
                      setPath={setPath}
                      setDrop={setDrop}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                </div>
              </li>

              {waypoints.map((waypoint, index) => (
                <li className="c-stepper__item2" key={index}>
                  <div className="c-stepper__content">
                    <h3 className="c-stepper__title">
                      <Box sx={{ marginLeft: 4 }}>
                        {" "}
                        {/* Adjust this value as needed */}
                        <Grid container sx={{ marginTop: 1 }}>
                          <Grid item xs={10} sm={10} md={10} gap={0}>
                            <MaterialAuto
                              type="waydrop"
                              waydrop={waypoints[index]}
                              waydropIndex={index}
                              setWaydrop={(i, value) => {
                                const updated = [...waypoints];
                                updated[i] = value;
                                setWaypoints(updated);
                              }}
                              setUserInteracting={setUserInteracting}
                              value={{ description: waypoint.address }}
                              onChange={(val) =>
                                handleWaypointChange(index, val)
                              }
                            />
                          </Grid>
                          <Grid

                          >
                            <CancelIcon
                              onClick={() => handleRemoveDrop(index)}
                              style={{ cursor: "pointer", color: "black", marginLeft: "10px", marginTop: "5px" }}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </h3>
                  </div>
                </li>
              ))}

              <li
                className="c-stepper__item1"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto
                      type="drop"
                      drop={drop}
                      pickup={pickup}
                      setPath={setPath}
                      setPickup={setPickup}
                      setDrop={setDrop}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                </div>

                {/* Add Drop Icon (Inline) */}
                {waypoints.length < 3 && bookType === 3 ? (
                  <AddCircleIcon
                    onClick={handleAddDrop}
                    style={{
                      cursor: "pointer",
                      color: "black",
                      marginLeft: 8,
                    }}
                  />
                ) : null}
              </li>
            </ol>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const TwoWayAddressSearchBar = ({ setDateValue }) => {
    const [twoWaydrop, setTwoWaydrop] = useState([]);

    const handleAddDrop = () => {
      const newPoint = { location: {} };
      setTwoWaypoints([...twoWaypoints, newPoint]);
      setTwoWaydrop([...twoWaypoints, newPoint]);
    };

    const handleRemoveDrop = (index) => {
      const updatedWayPath = [...wayPath];
      updatedWayPath.splice(index, 1);
      setTwoWayPath(updatedWayPath);

      const updatedWaypoints = [...twoWaypoints];
      updatedWaypoints.splice(index, 1);
      setTwoWaypoints(updatedWaypoints);
      setTwoWaydrop(updatedWaypoints);
    };

    return (
      <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
              Two Way Pickup & Drop
            </Typography>
          </Grid>

          <Grid item xs={8} className={classes.formContent}>
            <ol className="c-stepper" style={{ padding: 0 }}>
              {/* Pickup Location */}
              <li className="c-stepper__item">
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto1
                      className="pickup1"
                      type="pickup"
                      drop1={drop1}
                      pickup1={pickup1}
                      setPickup1={setPickup1}
                      setPath1={setPath1}
                      setDrop1={setDrop1}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                </div>
              </li>

              {twoWaypoints.map((waypoint, index) => (
                <li className="c-stepper__item2" key={index}>
                  <div className="c-stepper__content">
                    <h3 className="c-stepper__title">
                      <Box sx={{ marginLeft: 4 }}>
                        <React.Fragment key={index}>
                          <Grid container sx={{ marginTop: 1 }}>
                            <Grid item xs={10} sm={10} md={10}>
                              <MaterialAuto1
                                key={index}
                                type="waydrop"
                                waydrop1={twoWaypoints[index]}
                                waydropIndex1={index}
                                setWaydrop1={(i, value) => {
                                  const updated = [...twoWaypoints];
                                  updated[i] = value;
                                  setTwoWaypoints(updated);
                                }}
                                setUserInteracting={setUserInteracting}
                                value={{ description: waypoint.address }}
                                onChange={(val) =>
                                  handleWaypointChange(index, val)
                                }
                              />
                            </Grid>
                            <Grid

                            >
                              <CancelIcon
                                onClick={() => handleRemoveDrop(index)}
                                style={{ cursor: "pointer", color: "black", marginLeft: "10px", marginTop: "5px" }}
                              />
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      </Box>
                    </h3>
                  </div>
                </li>
              ))}

              <li
                className="c-stepper__item1"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto1
                      type="drop"
                      drop1={drop1}
                      pickup1={pickup1}
                      setPath1={setPath1}
                      setPickup1={setPickup1}
                      setDrop1={setDrop1}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                </div>

                {/* Add Drop Icon (Inline) */}
                {twoWaypoints.length < 3 && (
                  <AddCircleIcon
                    onClick={handleAddDrop}
                    style={{
                      cursor: "pointer",
                      color: "black",
                      marginLeft: 8,
                    }}
                  />
                )}
              </li>
            </ol>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const SubscriptionPlanPicker = ({
    selectedPlan,
    subscriptionPlan,
    activeIndexSub,
    setActiveIndexSub,
  }) => {

    const cardRefs = useRef([]);

    if (subscriptionPlan.length > 0 && !defaultPlanSet.current) {
      const storedPlan = sessionStorage.getItem("subscriptionInfo");
      const initialPlan = storedPlan
        ? JSON.parse(storedPlan)
        : subscriptionPlan[0];

      setSelectedPlan(initialPlan);
      setActiveIndexSub(
        subscriptionPlan.findIndex((plan) => plan._id === initialPlan._id)
      );
      sessionStorage.setItem("subscriptionInfo", JSON.stringify(initialPlan));

      defaultPlanSet.current = true;
    }

    const handleCardClick = useCallback((index, plan) => {
      if (!plan) return;

      setActiveIndexSub(index);

      setEndDate(null);
      setStartDate(null);

      setSelectedPlan(plan);

      sessionStorage.setItem("subscriptionInfo", JSON.stringify(plan));
    }, []);


    useEffect(() => {
      // Check if the ref for the active card exists
      if (cardRefs.current[activeIndexSub]) {
        // Use scrollIntoView to bring the card into sight
        cardRefs.current[activeIndexSub].scrollIntoView({
          behavior: "auto",
          inline: "nearest",
          block: "nearest",
        });
      }
    }, [activeIndexSub]);

    // console.log("activeIndexSub", activeIndexSub);


    return (
      <>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={4}>
              <Typography
                style={{ fontSize: "14px", fontWeight: "400", }}>
                Subscription Plan
              </Typography>
            </Grid>

            <Grid container item xs={8} flexDirection="row">
              <Box

                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "10px",
                  padding: "10px",
                }}
              >
                {subscriptionPlan.length !== 0 ? (
                  subscriptionPlan.map((plan, index) => (
                    <Card
                      key={index}
                      ref={el => (cardRefs.current[index] = el)}
                      className={
                        activeIndexSub === index
                          ? classes.activePlan
                          : classes.cardSubscription
                      }
                      onClick={() => handleCardClick(index, plan)}
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        minWidth: "150px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "12px", fontWeight: "bold" }}
                      >
                        {plan.planName}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {plan.tripTypeLabel}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "14px", fontWeight: "400" }}
                      >
                        {plan.typeLabel}
                      </Typography>
                    </Card>
                  ))
                ) : (
                  <Typography variant="subtitle2" style={{ color: "#ff0000" }}>
                    No Plans Available
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };




  const SchedulePickerOld = () => {
    const handleChange = (event) => {
      let bookNow = event.target.value;
      if (bookNow == "Now") {
        setBookNow(true);
        setDateValue(null);
      } else {
        setBookNow(false);
        let date = new Date(new Date().setMinutes(new Date().getMinutes() + 5));
        setTimeVaule(date);
        setDateValue(moment(date).format("YYYY-MM-DD hh:mm:ss A"));
      }
    };

    const [timeVaule, setTimeVaule] = React.useState(
      new Date(new Date().setHours(new Date().getHours() + 1))
    );

    let currentDateUTC = new Date();
    let currentDateCalFormat =
      currentDateUTC.getFullYear() +
      "-" +
      (currentDateUTC.getMonth() + 1) +
      "-" +
      currentDateUTC.getDate();

    const [pickerView, setPickerView] = useState("day"); // Track picker state

    const handleDateChange = (newValue) => {
      if (!newValue) return;

      if (pickerView === "day") {
        setPickerView("hours"); // Move to hours selection
      } else if (pickerView === "hours") {
        setPickerView("minutes"); // Move to minutes selection
      } else {
        setDateValue(moment(newValue).format("YYYY-MM-DD HH:mm:ss")); // Set final value
        setPickerView("day"); // Reset for next use
      }
    };

    let currentTimeCalFormat =
      currentDateCalFormat + " " + currentDateUTC.getMinutes() + ":00";

    return (
      <Box style={{ flexGrow: 1, marginTop: "25px" }}>
        <Grid container spacing={0} flexDirection="row" alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Box>
              {" "}
              <Typography
                style={{ fontSize: "14px", fontWeight: "400" }}
                variaint="subtitle2"
              >
                Pickup Time
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8} className={classes.formContent}>
            <Box style={{ display: 'flex', flexDirection: 'column', gap: "8px" }}>
              <Box
                style={{
                  // padding: "10px",
                  // marginLeft: "50px",
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                  // justifyContent: "start",
                }}
              >
                <div onChange={handleChange}>
                  <div className="sound-signal">
                    {/* <input
                type="radio"
                value="Now"
                name="booknow"
                id="soundsignal1"
                checked={bookNow}
              />
              <label for="soundsignal1" style={{ marginRight: "12px" }}>
                Now
              </label> */}
                    <input
                      type="radio"
                      value="Later"
                      name="booknow"
                      id="soundsignal2"
                      checked={!bookNow}
                    />
                    <label for="soundsignal2">Schedule</label>
                  </div>
                </div>
              </Box>


              {!bookNow ? (
                <Box
                  style={{
                    // marginTop: "16px",
                    // marginBottom: "16px",
                    marginRight: '15px',

                    // margin:"50px",

                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box
                    style={{
                      marginTop: '5px',
                      marginLeft: '5px',
                      // width:"140px",

                      marginRight: '20px'
                    }}
                  >
                    {/* <CustomDateTimePicker
                      bufferingTime={laterTime?.laterTime}
                      value={dateValue}
                      setDateValue={setDateValue}
                      minDateTime={new Date(Date.now() + (laterTime?.laterTime - 1) * 60 * 1000)}
                    /> */}

                    <CustomDateTimePicker
                      bufferingTime={laterTime?.laterTime}
                      value={dateValue}
                      setDateValue={setDateValue}
                    />
                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        renderInput={(params) => (
                          <TextFieldMui
                            id="outlined-select-currency-native"
                            size="small"
                            {...params}
                            error={false}
                          />
                        )}
                        label="Pickup time"
                        inputFormat="dd/MM/yyyy hh:mm a"
                        value={dateValue}
                        autoOk
                        onClose={() => {
                        }}
                        onAccept={(newValue) => {
                          setDateValue(
                            moment(newValue).format("YYYY-MM-DD hh:mm:ss A")
                          );
                        }}
                        clearable
                        onChange={(newValue) => {

                        }}
                        // minDateTime={
                        //   new Date(new Date().getTime() + 60 * 60 * 1000) // Current time plus one hour
                        // }
                        minDateTime={new Date(Date.now() + (laterTime?.laterTime - 1) * 60 * 1000)}
                        inputProps={{
                          min: currentTimeCalFormat,
                        }}
                      />
                    </LocalizationProvider> */}
                  </Box>
                </Box>
              ) : (
                ''
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const SchedulePicker = React.memo(
    ({
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      time,
      selectedModel,
      setTime,
      baseFare,
      setBaseFare,
      pickUp,
      drop,
      isHourlyPlan,
      setIsHourlyPlan,
      selectedDays,
      setSelectedDays,
      selectedPlan,
      selectedHourlyTime,
      setSelectedHourlyTime,
      subscriptionTripFare,
      setSubscriptionTripFare,
      twoWayPickupTime,
      setTwoWayPickupTime,
      totalDaysCount,
      setTotalDaysCount,
      setPickupTimeSlot,
      setDropTimeSlot,
      pickUp1,
      drop1,
      twoWayTripFare,
      setTwoWayTripFare,
      setIsRecurringBooking,
      recurringBookingEnable,
      setRecurringBookingEnable,
      path,
      path1,
      errMsg,
      setErrMsg
    }) => {
      const [view, setView] = useState("hours"); // ✅ Start in hours view
      const [selectedHour, setSelectedHour] = useState(null); // ✅ Track last selected hour
      // const [tempSelectedDays, setTempSelectedDays] = useState(selectedDays);

      const [open, setOpen] = useState(false);
      const [planStartDate, setPlanStartDate] = useState(null);
      const [planEndDateNew, setPlanEndDateNew] = useState(null);
      const [tempSelectedDays, setTempSelectedDays] = useState([]);

      const [dayTimeState, setDayTimeState] = useState({});




      useEffect(() => {
        if (isRecurringBooking) {
          setRecurringBookingEnable((prev) => prev || 1);
        }
      }, [setRecurringBookingEnable]);

      // console.log("isRecurringBooking",isRecurringBooking);
      // console.log("dayTimeState", dayTimeState);


      const handleDayTimeChange = (day, type, newValue) => {


        const updatedState = {
          ...dayTimeState,
          [day]: {
            ...dayTimeState[day],
            [type]: newValue ? dayjs(newValue).format("HH:mm") : null,
          },
        };

        setDayTimeState(updatedState);

        sessionStorage.setItem("dayTimeState", JSON.stringify(updatedState));
      };

      useEffect(() => {
        if (selectedPlan) {


          setPlanEndDateNew(
            moment(selectedPlan?.endDateTime).format("YYYY-MM-DD")
          );

          setPlanStartDate(
            moment(selectedPlan?.fromDateTime).format("YYYY-MM-DD")
          );

          if (!startDate || !endDate) {
            const currentDate = moment().format("YYYY-MM-DD");
            let planStartDate = currentDate;

            if (selectedPlan?.fromDateTime) {
              const selectedFromDate = moment(
                selectedPlan?.fromDateTime
              ).format("YYYY-MM-DD");

              if (currentDate > selectedFromDate) {
                planStartDate = currentDate;
              } else {
                planStartDate = selectedFromDate;
              }
            }

            setStartDate(planStartDate);

            let planEndDate;

            if (selectedPlan?.type === 1) {
              // Weekly: Add 1 week, but not beyond selectedPlan.endDateTime
              const nextWeek = moment().add(1, "week");
              const planEnd = moment(selectedPlan?.endDateTime);
              planEndDate = nextWeek.isAfter(planEnd)
                ? planEnd.format("YYYY-MM-DD")
                : nextWeek.format("YYYY-MM-DD");
            } else if (selectedPlan?.type === 2) {
              // Monthly: Add 1 month, but not beyond selectedPlan.endDateTime
              const nextMonth = moment().add(1, "month");
              const planEnd = moment(selectedPlan?.endDateTime);
              planEndDate = nextMonth.isAfter(planEnd)
                ? planEnd.format("YYYY-MM-DD")
                : nextMonth.format("YYYY-MM-DD");
            } else {
              // Hourly: Just set the end date as is
              planEndDate = moment(selectedPlan.endDateTime).format(
                "YYYY-MM-DD"
              );
            }

            setEndDate(planEndDate);
          }

          setIsHourlyPlan(selectedPlan?.typeLabel === "Hourly");

          setIsRecurringBooking(selectedPlan?.showRecurringBooking === 1);

        }
      }, [
        selectedPlan,
        endDate,
        setIsHourlyPlan,
        setStartDate,
        setEndDate,
        startDate,
        setIsRecurringBooking
      ]);




      useEffect(() => {
        if (view === "hours" && selectedHour !== null) {
          setTimeout(() => setView("minutes"), 10000); // ✅ Delay ensures proper transition
        }
      }, [selectedHour]);



      useEffect(() => {
        if (
          bookType === 3 &&
          pickUp1.address !== "" &&
          // pickUp1.address !== "" &&
          drop1.address !== "" &&
          // drop1.coords.lng() !== 0 &&
          selectedModel &&
          path1 &&
          distance2 &&
          !twoWayBaseFare
        ) {
          // console.log("pickUp1",pickUp1.coords.lat());


          // console.log("selectedModel", selectedModel);

          const obj = {
            "corporate_id": 0,
            "pickup_latitude": pickUp1.coords.lat(),
            "pickup_longitude": pickUp1.coords.lng(),
            "drop_latitude": drop1.coords.lat(),
            "drop_longitude": drop1.coords.lng(),
            "company_id": companyId,
            "zone_fare_applied": 0,
            "distance": distance2,
            "model_id": selectedModel?._id || 0,
            "overview_polyline": path1
          }

          console.log("called 5");

          axios
            .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj,
              {
                headers: { Authorization: `Bearer ${ANON_KEY}` }
              })
            .then((response) => {
              if (response.data.status === 1) {
                const fareDetailsObj = response.data.details?.carMakeFare;
                // console.log("fareDetailsObj", fareDetailsObj);
                if (fareDetailsObj) {

                  //setPlanBaseFare(fareDetailsObj.fare);

                  setTwoWayBaseFare(fareDetailsObj.fare);

                }
                setHasFetchedFare(true); // Mark that the API call has been made
              } else {
                // Handle error: show error message if needed
                // setshowErrorMessage(response.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }, [path1]);




      // console.log("twoWayBaseFare", twoWayBaseFare);




      useEffect(() => {
        if (startDate && endDate && planBaseFare && planBaseFare !== "") {
          let count = 0;
          let firstWeekCount = 0;

          let currentDate = moment(startDate).startOf("day");
          const end = moment(endDate).startOf("day");

          const firstWeekEnd = moment(startDate).clone().add(6, 'days').startOf("day");

          // console.log("selectedDays",selectedDays);

          while (currentDate.isSameOrBefore(end)) {
            const dayOfWeek = currentDate.weekday(); // 0 (Sun) - 6 (Sat)

            if (selectedDays.includes(dayOfWeek)) {
              count++;

              if (currentDate.isSameOrBefore(firstWeekEnd)) {
                firstWeekCount++;
              }
            }

            currentDate.add(1, "day");
          }

          const start = moment(startDate).startOf("day");
          const totalDays = end.diff(start, 'days') + 1;

          // console.log("count", count);


          setTotalDaysCount(count);
          setFirstWeekDaysCount(firstWeekCount);
          setInBetweenDaysCount(totalDays);

          const calculatedFare = count * planBaseFare;
          const twoWayFare = count * twoWayBaseFare;

          setSubscriptionTripFare(parseFloat(calculatedFare.toFixed(2)));

          if (selectedPlan.tripType === 2) {
            setTwoWayTripFare(parseFloat(twoWayFare.toFixed(2)));
          }
        }
      }, [startDate, endDate, planBaseFare, selectedDays, twoWayBaseFare]);






      const handleEndDateChange = (newValue) => {
        // console.log("planEndDateNew->", planEndDateNew);
        // console.log("new end date->", newValue);

        if (newValue) {
          const formattedDate = moment(newValue).format("YYYY-MM-DD");

          if (
            moment(formattedDate).isAfter(moment(startDate), "day") &&
            moment(formattedDate).isSameOrBefore(moment(planEndDateNew), "day")
          ) {
            // console.log("formattedDate->", formattedDate);

            setEndDate(formattedDate);
          } else {
            alert(
              `End Date must be between ${moment(startDate).format(
                "DD/MM/YYYY"
              )} and ${moment(planEndDateNew).format("DD/MM/YYYY")}`
            );
          }
        }
      };

      const handleStartDateChange = (newValue) => {
        if (newValue) {
          const selectedDate = moment(newValue).format("YYYY-MM-DD");

          // Ensure start date is not greater than end date
          if (moment(selectedDate).isAfter(moment(endDate))) {
            alert("Start date cannot be greater than the end date!");
            return;
          }

          // Ensure start date is not less than planStartDate
          if (moment(selectedDate).isBefore(moment(planStartDate))) {
            alert("Start date cannot be before the plan start date!");
            return;
          }

          // console.log("New Start Date Value -->", selectedDate);
          setStartDate(selectedDate);
        }
      };




      const daySlot = useMemo(
        () => [
          "All",
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        []
      );


      useEffect(() => {
        // Sync rawSelectedDays when selectedDays change
        const selectedDayNames = selectedDays.map((index) => daySlot[index + 1]);
        setTempSelectedDays(selectedDays);
        setRawSelectedDays(selectedDayNames);
      }, [selectedDays]);

      const [rawSelectedDays, setRawSelectedDays] = useState([]); // string[] like ["Monday", "Tuesday"]

      const handleDayChange = (event) => {
        const { value } = event.target;

        if (value.includes("All")) {
          setRawSelectedDays(
            rawSelectedDays.length === 7 ? [] : daySlot.slice(1) // ["Sunday", ..., "Saturday"]
          );
        } else {
          setRawSelectedDays(value);
        }
      };

      const handleClose = () => {
        const indexes = rawSelectedDays.map((day) => daySlot.indexOf(day) - 1); // convert to 0–6
        setTempSelectedDays(indexes);
        setSelectedDays(indexes);

        // Build new dayTimeState based on current selection
        const newState = { ...dayTimeState }; // start from current state
        indexes.forEach((i) => {
          const name = daySlot[i + 1];
          if (!newState[name]) {
            newState[name] = {
              pickup: "00:00",
              ...(selectedPlan?.tripType === 2 ? { drop: "00:00" } : {}),
            };
          }
        });

        // Remove any deselected days
        Object.keys(newState).forEach((day) => {
          if (!rawSelectedDays.includes(day)) {
            delete newState[day];
          }
        });

        // Update state and sessionStorage immediately
        setDayTimeState(newState);
        sessionStorage.setItem("dayTimeState", JSON.stringify(newState));

        setOpen(false);
      };

      const memoizedDaySlot = useMemo(() => daySlot, [daySlot]);
      const memoizedPlan = useMemo(() => selectedPlan, [selectedPlan]);
      const memoizedTempSelectedDays = useMemo(() => tempSelectedDays, [tempSelectedDays]);

      return (
        <>
          {selectedPlan?.tripType === 2 && <TwoWayAddressSearchBar />}

          <Box style={{ flexGrow: 1, marginTop: "25px" }}>
            <Grid container spacing={1} flexDirection="row" alignItems="center">
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                  Day Slot
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <FormControl style={{ width: "100%" }}>
                  <Select
                    multiple
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={handleClose}
                    value={rawSelectedDays}
                    onChange={handleDayChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={{
                      disableScrollLock: true,
                      disableAutoFocusItem: true,
                      PaperProps: {
                        style: {
                          maxHeight: 224,
                          overflowY: "auto",
                        },
                      },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    {daySlot.map((day, index) => (
                      <MenuItem
                        key={day}
                        value={day}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Checkbox
                          color={companyTheme?.primaryColorCode}
                          checked={
                            day === "All"
                              ? rawSelectedDays.length === 7
                              : rawSelectedDays.includes(day)
                          }
                        />
                        <ListItemText primary={day} />
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {isHourlyPlan ? (
            <Box style={{ flexGrow: 1, marginTop: "20px" }}>
              <Grid
                container
                spacing={1}
                flexDirection="row"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                    Hours
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <FormControl style={{ width: "100%" }}>
                    <Select
                      value={selectedHourlyTime}
                      onChange={(e) => {
                        setSelectedHourlyTime(e.target.value);
                      }}
                      input={<OutlinedInput />}
                    >
                      {Array.from(
                        { length: selectedPlan?.hours || 0 },
                        (_, i) => i + 1
                      ).map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          ) : null}

          {isRecurringBooking ? (
            <Box style={{ flexGrow: 1, marginTop: "20px" }}>
              <Grid container spacing={1} flexDirection="row" alignItems="center">
                <Grid item xs={4}>
                  <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                    Recurring Booking
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Checkbox
                    color={companyTheme?.primaryColorCode}
                    checked={recurringBookingEnable === 1}
                    onChange={(e) =>
                      setRecurringBookingEnable(e.target.checked ? 1 : 2)
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          ) : null}

          {/* Start Date */}
          <Box style={{ flexGrow: 1, marginTop: "8px" }}>
            <Grid
              container
              spacing={1}
              flexDirection="column"
              alignItems="center"
            >
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                  Start Date
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ marginRight: "15px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Start Date"
                        inputFormat="dd/MM/yyyy"
                        value={
                          startDate ? moment(startDate, "YYYY-MM-DD") : null
                        }
                        onChange={handleStartDateChange}
                        renderInput={(params) => (
                          <TextField size="small" {...params} error={false} />
                        )}
                        disablePast
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>

              {/* End Date */}
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                  End Date
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ marginRight: "15px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="End Date"
                        inputFormat="dd/MM/yyyy"
                        value={endDate || null}
                        onChange={handleEndDateChange}
                        renderInput={(params) => (
                          <TextField
                            id="outlined-select-currency-native"
                            size="small"
                            {...params}
                            error={false}
                          />
                        )}
                        minDate={moment(startDate)}
                        maxDate={
                          planEndDateNew
                            ? moment(planEndDateNew).toDate()
                            : undefined
                        }
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>


          {/* Pickup Time */}
          {tempSelectedDays && tempSelectedDays.length !== 0 && (
            <CustomerTimePicker
              tempSelectedDays={memoizedTempSelectedDays || []}
              daySlot={memoizedDaySlot}
              selectedPlan={memoizedPlan}
              dayTimeState={dayTimeState}
              setDayTimeState={setDayTimeState}
              startDate={startDate}
            />
          )}

          <Box style={{ flexGrow: 1, marginTop: "8px" }}>
            <Grid
              container
              spacing={1}
              flexDirection="column"
              alignItems="center"
            >
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>

                </Typography>
              </Grid>

              {errMsg && (
                <Typography color="error"
                  variant="caption"
                  sx={{
                    mt: 0.5, display: 'block', opacity: 1, height: 'auto',
                    overflow: 'hidden', transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out',

                  }}>
                  {errMsg}
                </Typography>)}

            </Grid>
          </Box>




          {/* {subscriptionTripFare !== null &&
            subscriptionTripFare !== undefined &&
            selectedDays.length !== 0 &&
            !isNaN(subscriptionTripFare) && (
              <Box style={{ flexGrow: 1, marginTop: "8px" }}>
                <Grid
                  container
                  spacing={1}
                  flexDirection="row"
                  alignItems="center"
                >
                  <Grid item xs={4}>
                    <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                      One Way Trip Fare
                    </Typography>
                  </Grid>

                  <Grid item xs={8}>
                    <Box style={{ marginRight: 15 }}>
                      <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                        {subscriptionTripFare > 0
                          ? `${subscriptionTripFare} AED`
                          : "-"}{" "}
                        ({totalDaysCount + " Days"})
                      </Typography>
                    </Box>
                  </Grid>

                  {selectedPlan.tripType === 2 &&
                    pickUp1.coords.lat() !== 0 &&
                    pickUp1.coords.lng() !== 0 &&
                    drop1.coords.lat() !== 0 &&
                    drop1.coords.lng() !== 0 && (
                      <>
                        <Grid item xs={4}>
                          <Typography
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            Two Way Trip Fare
                          </Typography>
                        </Grid>

                        <Grid item xs={8}>
                          <Box style={{ marginRight: 15 }}>
                            <Typography
                              style={{ fontSize: 14, fontWeight: 400 }}
                            >
                              {twoWayTripFare > 0
                                ? `${twoWayTripFare} AED`
                                : "-"}{" "}
                              ({totalDaysCount + " Days"})
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    )}
                </Grid>
              </Box>
            )} */}
        </>
      );
    }
  );

  const SearchModel = () => {
    return (
      <Box>
        <LinearProgress style={{ marginTop: "5px" }} />
      </Box>
    );
  };
  const [modelCat, setModelCat] = React.useState("");

  useEffect(() => {
    if (bookType !== 3) {
      sessionStorage.removeItem("subscriptionInfo");
    }
  }, []);

  const defaultPlanSet = useRef(false);

  // console.log("companyId", companyId);


  useEffect(() => {
    const fetchPlans = async () => {
      if (!companyId) return; // ✅ early return if no companyId

      try {
        const domain = sessionStorage.getItem("x_company_domain");

        const response = await axios.post(
          `${BACKEND_URL}/subscriptionPlanList?fromWebBooker=1`,
          { companyId },
          {
            headers: {
              Authorization: `Bearer ${ANON_KEY}`,
              x_company_domain: domain
            }
          }
        );

        if (response?.data?.status === 1) {
          const plans = response?.data?.responseData?.subscriptions || [];
          setSubscriptionPlan(plans);
        } else {
          setSubscriptionPlan([]);
        }
      } catch (error) {
        console.error("Error fetching subscription plans:", error);
        setSubscriptionPlan([]);
      }
    };

    fetchPlans();
  }, [companyId]);


  const [openAdd3, setOpenAdd3] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("");
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);

  useEffect(() => {
    // console.log("showErrorMessage", showErrorMessage);

    // Remove the old value before saving the new one
    sessionStorage.removeItem("showErrorMessage");

    if (showErrorMessage) {
      sessionStorage.setItem(
        "showErrorMessage",
        JSON.stringify(showErrorMessage)
      );
    }

    if (showErrorMessage?.status === 1) {
      navigate("/bookingconfirmation");
    } else if (showErrorMessage?.status === -1) {
      setAlertMsg(showErrorMessage?.message);
      setOpenAdd3(true);
    }
  }, [showErrorMessage]);

  const handleAddClose3 = () => {
    setOpenAdd3(false);
    // setOpenOtp(true);
  };

  const [val, setVal] = useState("");

  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [newUser, setNewUser] = useState(null);

  const [openAdd4, setOpenAdd4] = React.useState(false);

  // const [waypoints, setWaypoints] = useState([]);
  const [twoWaypoints, setTwoWaypoints] = useState([]);

  const [wayPath, setWayPath] = useState([]);
  const [twoWayPath, setTwoWayPath] = useState([]);

  const handleCloseOtp = () => {
    setOpenOtp(false);
  };



  const handleChangeValidate = (e) => {
    sessionStorage.removeItem("otp");

    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }
    sessionStorage.setItem("otp", e.target.value);
  };


  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));
  var otp = sessionStorage.getItem("otp");

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const ResendOtp = () => {
    let obj;

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    if (bookType === 3) {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1, // Only included if bookType is 3
        email: a.email
      };
    } else {
      obj = {
        name: a.firstName + " " + a.lastName,
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        email: a.email
      };
    }

    setLoader3(true);
    // setLoader2(true);

    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader3(false);
          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));
        } else if (Response.data.status === -1) {
          setLoader3(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          setCountDown(null);
          setLoader3(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function getPassengerUpdate(trip_id) {
    //   // console.log("Helllllooooo", pickupLatLng.lat());

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        // console.log("savebook statusssssss--->", Response.data.status);
        //{"message":"Your booking is confirmed.","trip_id":901966,"is_first_trip":"","event_ride_count":"0","status":1,"user_key":"7e1b314f553e5981e9f11507ee08db2933befc35403cc0c0f715d7c48bde6764_61b73888b374ae141f7f51d5"}
        if (Response.data.status == 1) {
          let fareDetails = Response.data.fare_details;
          // setTripInProgress(true);
          setTripID(trip_id);
          setsearchingDriver(false);
          //setshowErrorMessage("")

          // alert(Response.data.message);
          // setshowErrorMessage(Response.data.message)
        } else {
          //   setSearchingCar(false);
          // alert(Response.data.message);
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        console.log("error Comes:", error);
      });
  }

  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    // setOpenOtp(false);

    if (bookType === 3) {
      const formattedStartDate = moment(startDate).format("YYYY-MM-DD HH:mm:ss");


      const formattedEndDate = moment(endDate).format("YYYY-MM-DD HH:mm:ss");

      // console.log("selectedModel", selectedModel);

      // console.log("planBaseFare", planBaseFare);

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");




      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      // console.log(dropLocationInfo);


      // console.log("twoWayBaseFare", twoWayBaseFare);

      const postData = {
        _id: passengerId?.passengerId,
        newUser: newUser,
        motorModelId: selectedModel._id,
        otp: otp,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: address,
          latitude: pickup.coords.lat(),
          longitude: pickup.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        // twoWayPickupTime: formattedTwoWayPickupTime,
        farePerTrip: planBaseFare,
        totalFare: subscriptionTripFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        daySlot: selectedDays,
        hours: selectedHourlyTime,
        isRecurringBooking: isRecurringBooking,
        ...(subscriptionDetailsNew?.tripType === 2 && {
          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayPickupLocationInfo: {
            address: pickup1.address,
            latitude: pickup1.coords.lat(),
            longitude: pickup1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayBaseFare,
          twoWaytotalFare: twoWayTripFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };

      // console.log("postData", postData);


      const domain = sessionStorage.getItem("x_company_domain");

      // console.log("passsengerId", passsengerId);

      console.log("selectedHourlyTime", selectedHourlyTime);


      axios
        .post(
          `${BACKEND_URL}/createEnquiry?fromWebBooker=1`,

          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          // console.log('statusssssss--->', Response.data.status);
          // setOpenAdd3Success(false)
          if (Response.data.status >= 1) {
            //  let fareDetails = Response.data.fare_details;

            setOpenOtp(false);
            setAlertMsg(Response.data.message);
            setLoader2(false);

            if (Response.data.status === 1) {
              //  console.log('passengerId', Response?.data?.detail?.passengerInfo?.id);

              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));

              setOpenAdd3Success(true);

              setshowErrorMessage(Response.data);
            } else {
              setOpenAdd3(true);
            }

            // getPassengerUpdate(Response.data.detail.passenger_tripid);
          }
          // else if (Response.data.status === -2) {
          //   setAlertMsg(Response.data.message);
          //   setLoader2(false);
          //   setOpenAdd3(true);
          // }
          else {

            setBookType(3);

            // setPickup("");
            // setDrop("");
            setshowErrorMessage(Response.data);

            // sessionStorage.setItem(
            //   "passengerInfo",
            //   JSON.stringify(Response?.data?.detail?.passengerInfo)
            // );

            const obj2 = {
              passengerId: Response.data.detail.passengerInfo.id
            };
            sessionStorage.setItem('passengerId', JSON.stringify(obj2));

            // sessionStorage.setItem("passengerId", JSON.stringify(obj2));

            // sessionStorage.setItem(
            //   "passengerId",
            //   JSON.stringify(Response?.data?.detail?.passengerInfo?.id)
            // );

            if (Response.data.isVerified) {
              setOpenOtp(false);
            } else {
              setOpenOtp(true);
            }
            setAlertMsg(Response.data.message);
            // setOpenAdd3(true);
            // setOpenAdd3Success(true);
            setLoader2(false);

            // sessionStorage.removeItem("passengerInfo");
            // sessionStorage.removeItem("passengerId");

            // setshowErrorMessage(Response.data);
            // setsearchingDriver(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1];
          const fareAmount = match[2];
          estimatedFare = fareAmount;
        }
      }

      // console.log("dateValue 3", dateValue)
      //  console.log("selectedHourlyBookingTime", selectedHourlyBookingTime)

      const domain = sessionStorage.getItem("x_company_domain");

      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickup.coords.lat().toString(),
        longitude: pickup.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        scheduleBookType: bookType,

        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,

        }),
        ...(bookType !== 4 && {
          approxTripFare: estimatedFare,
        }),
        // approxTripFare: drop.address !== "" ? approxTripFare : 0,
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };

      // console.log("postData 3", postData);

      // console.log("selectedModel", selectedModel);

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, x_company_domain: domain }
          }
        )
        .then((Response) => {
          // console.log('savebook statusssssss--->', Response.data.status);
          if (Response.data.status >= 1) {
            //  let fareDetails = Response.data.fare_details;
            setLoader2(false);
            // console.log('savebook statusssssss--->', Response.data);

            if (dateValue) {
              setshowErrorMessage(Response.data);


              // if (Response.data.newUser === 1) {
              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );
              // sessionStorage.setItem("passengerId", JSON.stringify(obj2));
              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));

              //   sessionStorage.setItem(
              //     'passengerInfoDummy',
              //     JSON.stringify(Response.data.detail.passengerInfo)
              //   );
              //   sessionStorage.setItem('newUser', JSON.stringify({ newUser: 0 }));
              // } else {
              //   const items = JSON.parse(
              //     sessionStorage.getItem('passengerInfoDummy')
              //   );
              //   sessionStorage.setItem('passengerInfo', JSON.stringify(items));
              // }

              // setsearchingDriver(false);
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }

            // getPassengerUpdate(Response.data.detail.passenger_tripid);
          }
          // else if (Response.data.status === -2) {
          //   setAlertMsg(Response.data.message);
          //   setLoader2(false);
          //   setOpenAdd3(true);
          // }
          else {
            //   alert(Response.data.message);
            // console.log('===', Response.data);
            setshowErrorMessage(Response.data);
            setAlertMsg(Response.data.message);
            // sessionStorage.removeItem("passengerInfo");
            // sessionStorage.removeItem("passengerId");

            // setOpenAdd3(true);
            // setOpenAdd3Success(true);
            setLoader2(false);

            // setshowErrorMessage(Response.data);
            // setsearchingDriver(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleAddCloseSuccessNew = () => {
    setOpenAdd3Success(false);
    // setOpenOtp(false);
  };

  const handleAddCloseSuccess = () => {
    setOpenAdd3Success(false);
    // window.location.reload();
  };

  // getNearestDriver("0.0","0.0","0.0","0.0");
  return (
    <>
      <Dialog
        open={openAdd3}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddClose3}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/reject.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3 style={{ color: "red" }}>{alertMsg}</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddClose3}
            variant="contained"
            color="white"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAdd3Success}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddCloseSuccess}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/greenTick.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3>{alertMsg}123</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddCloseSuccessNew}
            variant="contained"
            color="white"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOtp}
        // onClose={handleCloseOtp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ boxShadow: "1px 1px 1px 1px" }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ paddingTop: "6px", paddingRight: "14px" }}
        >
          <Grid
            container
            spacing={3}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid item>{"Please, Enter OTP!"}</Grid>
            <Grid item>
              <CloseIcon
                onClick={handleCloseOtp}
                style={{
                  color: "red",
                  border: "1px solid red",
                  cursor: "pointer",
                }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <>
            <TextField
              id="outlined-basic"
              label="OTP"
              inputProps={{ maxLength: 4 }}
              style={{ marginTop: "25px" }}
              value={val}
              onChange={handleChangeValidate}
              fullWidth
              variant="outlined"
            />
            <a
              style={{
                fontSize: "13px",
                marginTop: "5px",
                color:
                  countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                pointerEvents:
                  countDown !== null && countDown !== 0 ? "none" : "",
                cursor: countDown !== null && countDown !== 0 ? "" : "pointer",
              }}
              onClick={() => ResendOtp(pickup.address)}
              disabled={countDown !== null && countDown !== 0 ? true : false}
            >
              Resend OTP{" "}
              {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
            </a>
          </>
        </DialogContent>
        <DialogActions>
          <>
            <Button
              onClick={() => BookTaxi(pickup.address)}
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                borderRadius: "4px",
                color: "white",
              }}
              disabled={val.length === 4 ? false : true}
              variant="contained"
            >
              {loader2 ? (
                <CircularProgress style={{ width: "30px", height: "30px", color: "white" }} />
              ) : (
                "Verify"
              )}
            </Button>
            {/* <Button
                onClick={() => ResendOtp(pickUp.address)}
                style={{
                  backgroundColor: '#05232d',
                  borderRadius: '4px'
                }}
                disabled={countDown !== null && countDown !== 0 ? true : false}
                variant="contained"
                color="primary"
              >
                {' '}
                {loader3 ? (
                  <CircularProgress style={{ width: '30px', height: '30px' }} />
                ) : (
                  `Resend OTP ${countDown}`
                )}
              </Button> */}
          </>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAdd4}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddClose4}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/reject.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3 style={{ color: "red" }}>{alertMsg}</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddClose41}
            variant="contained"
            color="color"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.newDesignRoot}>
        <div
          // style={{
          //   backgroundColor: '#f9fafb',
          //   position: 'relative',
          //   width: '100%',
          //   // height: "100%",
          //   display: 'flex',
          //   flexDirection: 'column'
          // }}
          className={classes.formHead}
        >

          <div
            style={{
              flexGrow: 1,
            }}
          >
            <Grid container spacing={0}>
              <Grid item xs={12} md={12}>
                <ExtraForm
                  guest={guest}
                  pickUp={pickup}
                  modelCat={modelCat}
                  setModelCat={setModelCat}
                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                
              </Grid> */}
            </Grid>
          </div>

          {/* {fullLoader ? (
            <CircularProgress
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "90vh",
                margin: "auto",
                overflow: "hidden",
              }}
            />
          ) : searchingDriver ? (
            <WaitingForDriver
              selectedModel={selectedModel}
              pickupAddress={pickup.address}
              dropAddress={drop.address}
              dateValue={dateValue}
            />
          ) : tripID !== "" ? (
            <ConfirmedDriver
              tripID={tripID}
              tripData={tripData}
              selectedModel={selectedModel}
              setshowErrorMessage={setshowErrorMessage}
              setSelectedModel={setSelectedModel}
              setTripID={setTripID}
              setTripData={setTripData}
              setFullLoader={setFullLoader}
              estimatedTime={estimatedTime}
            />
          ) : detailViewIndex ? (
            <DetailPage
              setDetailViewIndex={setDetailViewIndex}
              selectedModel={selectedModel}
              setTripData={setTripData}
            />
          ) : (
            null
          )} */}

          {/* {!showErrorMessage && !searchingDriver && tripID === "" ? ( */}
          <>
            <BookButton
              selectedModel={selectedModel}
              driverDetails={driverDetails}
              dateValue={dateValue}
              pickUp={pickup}
              drop={drop}
              setsearchingDriver={setsearchingDriver}
              setshowErrorMessage={setshowErrorMessage}
              setTripID={setTripID}
              setBookType={setBookType}
              bookType={bookType}
              setTransferStatus={setTransferStatus}
              fullDayStatus={fullDayStatus}
              transferStatus={transferStatus}
              halfDayStatus={halfDayStatus}
              // roundTripStatus={roundTripStatus}
              setFullDayStatus={setFullDayStatus}
              setHalfDayStatus={setHalfDayStatus}
              setApproxTripFare={setApproxTripFare}
              subscriptionStatus={subscriptionStatus}
              setSubscriptionStatus={setSubscriptionStatus}
              hourlyStatus={hourlyStatus}
              setHourlyStatus={setHourlyStatus}
              activeIndex={activeIndex}
              fareDetails={fareDetails}
              // setRoundTripStatus={setRoundTripStatus}
              error={error}
              setError={setError}
              guest={guest}
              approxTripFare={approxTripFare}
              distance={distance}
              duration={duration}
              planBaseFare={planBaseFare}
              setPlanBaseFare={setPlanBaseFare}
              selectedDays={selectedDays}
              selectedHourlyTime={selectedHourlyTime}
              subscriptionTripFare={subscriptionTripFare}
              setTotalDaysCount={setTotalDaysCount}
              setPickupTimeSlot={setPickupTimeSlot}
              setDropTimeSlot={setDropTimeSlot}
              pickUp1={pickup1}
              drop1={drop1}
              twoWayBaseFare={twoWayBaseFare}
              setTwoWayBaseFare={setTwoWayBaseFare}
              twoWayTripFare={twoWayTripFare}
              setTwoWayTripFare={setTwoWayTripFare}
              selectedHourlyBookingTime={selectedHourlyBookingTime}
              recurringBookingEnable={recurringBookingEnable}
              companyId={companyId}
              companyTheme={companyTheme}
              modelHourlyFare={modelHourlyFare}
              setHourlyErr={setHourlyErr}
            />

            {bookType === 3 ? (
              <SubscriptionPlanPicker
                selectedPlan={selectedPlan}
                subscriptionPlan={subscriptionPlan}
                activeIndexSub={activeIndexSub}
                setActiveIndexSub={setActiveIndexSub}
                fareDetails1={fareDetails1}
              />
            ) : null}

            <AddressSearchBar />

            {bookType === 4 && pickup.coords.lat() !== 0 && drop.coords.lat() !== 0 ? (
              <>
                <Box style={{ flexGrow: 1, marginTop: "20px" }}>
                  <Grid
                    container
                    spacing={1}
                    flexDirection="row"
                    alignItems="center"
                  >
                    <Grid item xs={4}>
                      <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                        Hours
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl style={{ width: "100%" }}>
                        {/* <InputLabel shrink={true}>Select Hours</InputLabel> */}
                        <Select
                          value={selectedHourlyBookingTime || ""}
                          onChange={(e) => {
                            // console.log("duration", duration);
                            setSelectedHourlyBookingTime(e.target.value);
                            setErrMsg("");
                          }}
                          // input={<OutlinedInput label="Select Hours" />}
                          input={<OutlinedInput />}
                        >
                          {/* {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))} */}

                          <MenuItem value="6">Half Day (6 hours)</MenuItem>
                          <MenuItem value="12">Full Day (12 hours)</MenuItem>

                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => {
                            const durationInHours = Math.ceil(duration / 60);
                            const shouldDisable = duration < 60 ? false : num <= durationInHours;



                            return (
                              <MenuItem
                                key={num}
                                value={num}
                                disabled={shouldDisable}
                              >
                                {num}
                              </MenuItem>
                            );
                          })}

                          {/* {Array.from(
                        { length: selectedPlan?.hours || 0 },
                        (_, i) => i + 1
                      ).map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))} */}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>

                <Box style={{ flexGrow: 1, marginTop: "8px" }}>
                  <Grid
                    container
                    spacing={1}
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Grid item xs={4}>
                      <Typography style={{ fontSize: "14px", fontWeight: "400", }}>

                      </Typography>
                    </Grid>

                    {errMsg && (
                      <Typography color="error"
                        variant="caption"
                        sx={{
                          mt: 0.5, display: 'block', opacity: 1, height: 'auto',
                          overflow: 'hidden', transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out',

                        }}>
                        {errMsg}
                      </Typography>)}

                  </Grid>
                </Box>
              </>
            ) : null}

            {bookType === 3 ? (
              <SchedulePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                time={time}
                setTime={setTime}
                selectedModel={selectedModel}
                baseFare={planBaseFare}
                setBaseFare={setPlanBaseFare}
                path={path}
                pickUp={pickup}
                drop={drop}
                isHourlyPlan={isHourlyPlan}
                setIsHourlyPlan={setIsHourlyPlan}
                selectedDays={selectedDays}
                setSelectedDays={setSelectedDays}
                selectedPlan={selectedPlan}
                selectedHourlyTime={selectedHourlyTime}
                setSelectedHourlyTime={setSelectedHourlyTime}
                subscriptionTripFare={subscriptionTripFare}
                setSubscriptionTripFare={setSubscriptionTripFare}
                twoWayPickupTime={twoWayPickupTime}
                setTwoWayPickupTime={setTwoWayPickupTime}
                totalDaysCount={totalDaysCount}
                setTotalDaysCount={setTotalDaysCount}
                setPickupTimeSlot={setPickupTimeSlot}
                setDropTimeSlot={setDropTimeSlot}
                path1={path1}
                pickUp1={pickup1}
                drop1={drop1}
                twoWayBaseFare={twoWayBaseFare}
                setTwoWayBaseFare={setTwoWayBaseFare}
                twoWayTripFare={twoWayTripFare}
                setTwoWayTripFare={setTwoWayTripFare}
                // setDayTimeState={setDayTimeState}
                // dayTimeState={dayTimeState}
                isRecurringBooking={isRecurringBooking}
                setIsRecurringBooking={setIsRecurringBooking}
                recurringBookingEnable={recurringBookingEnable}
                setRecurringBookingEnable={setRecurringBookingEnable}
                errMsg={errMsg}
                setErrMsg={setErrMsg}

              />
            ) : (
              <SchedulePickerOld />
            )}

            <BookButtonNew
              selectedModel={selectedModel}
              driverDetails={driverDetails}
              dateValue={dateValue}
              selectedPlan={selectedPlan}
              pickUp={pickup}
              drop={drop}
              setsearchingDriver={setsearchingDriver}
              setshowErrorMessage={setshowErrorMessage}
              setTripID={setTripID}
              setBookType={setBookType}
              bookType={bookType}
              setTransferStatus={setTransferStatus}
              fullDayStatus={fullDayStatus}
              transferStatus={transferStatus}
              halfDayStatus={halfDayStatus}
              // roundTripStatus={roundTripStatus}
              setFullDayStatus={setFullDayStatus}
              setHalfDayStatus={setHalfDayStatus}
              setApproxTripFare={setApproxTripFare}
              subscriptionStatus={subscriptionStatus}
              setSubscriptionStatus={setSubscriptionStatus}
              hourlyStatus={hourlyStatus}
              setHourlyStatus={setHourlyStatus}
              activeIndex={activeIndex}
              fareDetails={fareDetails}
              error={error}
              setError={setError}
              // setRoundTripStatus={setRoundTripStatus}
              guest={guest}
              approxTripFare={approxTripFare}
              startDate={startDate}
              endDate={endDate}
              time={time}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setTime={setTime}
              setPickup={setPickup}
              setDrop={setDrop}
              planBaseFare={planBaseFare}
              setPlanBaseFare={setPlanBaseFare}
              selectedDays={selectedDays}
              selectedHourlyTime={selectedHourlyTime}
              subscriptionTripFare={subscriptionTripFare}
              twoWayPickupTime={twoWayPickupTime}
              distance={distance}
              duration={duration}
              waypoints={waypoints}
              pickUp1={pickup1}
              drop1={drop1}
              twoWaypoints={twoWaypoints}
              twoWayBaseFare={twoWayBaseFare}
              twoWayTripFare={twoWayTripFare}
              selectedHourlyBookingTime={selectedHourlyBookingTime}
              recurringBookingEnable={recurringBookingEnable}
              fareDetails1={fareDetails1}
              companyId={companyId}
              companyTheme={companyTheme}
              modelHourlyFare={modelHourlyFare}
              distance2={distance2}
              duration2={duration2}
              errMsg={errMsg}
              setErrMsg={setErrMsg}
              setHourlyErr={setHourlyErr}
            />
          </>
          {/* ) : (
            ""
          )} */}

          {/*<Message />*/}
          {/* <DetailPage /> */}
          {/* <ConfirmedDriver /> */}
          {/* <WaitingForDriver /> */}
        </div>
      </div>
    </>
  );
}
